import React, { Component } from "react"
import styled from "styled-components"
import fetch from "isomorphic-fetch"
import ReactModal from "react-modal"
import bugsnag from "bugsnag-js"
import Loader from "dumbComponents/common/UI/Loader"
import ColorPickerWithInput from "dumbComponents/common/UI/ColorPickerWithInput"
import US_STATES from "shared/US_STATES.json"
import root, { alert } from "window-or-global"
import queryString from "query-string"

import moment from "moment"
// import Button from "dumbComponents/common/UI/Button"
import JobCreateModal from "components/Jobs/JobCreateModal"
import JobViewModal from "components/Jobs/JobViewModal"
import ImageUploader from "react-images-upload"
import RichTextEditor from "dumbComponents/common/RichTextEditor/RichEditor"
import PhotoEditor from "dumbComponents/common/PhotoEditor"
import { SALES_REPRESENTATIVE } from "dumbComponents/BrokerDashboard/GlobalPages/Resources/data"
import TextInput from "dumbComponents/BrokerDashboard/Comp/TextInput"

import {
  withRouter,
} from "react-router-dom"
import _, { parseInt, get } from "lodash"
import {
  Button,
  Tabs,
  Form, Input, Modal, Switch, Flex, Row, Col, List, Select, Table, Tag, message, PageHeader, Radio, Space, InputNumber, DatePicker, Checkbox
} from "antd"
import { ExclamationCircleOutlined, CloseCircleTwoTone, RightOutlined, DownOutlined, PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons"
import Notifications, { notify } from "react-notify-toast"
const baseUrl = process.env.REACT_APP_API_BASE_URL
const token = process.env.REACT_APP_SECRET_ID
const originalKey = process.env.REACT_APP_BUGSNAG_KEY
const bugsnagClient = bugsnag(originalKey)
const { TabPane } = Tabs
const { confirm } = Modal

const dealForm = {
  width: "50%",
  height: "100px",
}

const RichTextEditorWrapper = styled.div`
  margin-top: 10px;
  .codex-editor__redactor {
    background: white;
    margin-top: 10px;
    font-size: 16px;
    font-weight: 200;
    padding: 10px;
    min-height: 120px;
    margin-bottom: 0px !important;
    /* padding-bottom: 200px !important; */
    ${props => props.pb && `
      padding-bottom: ${props.pb} !important;
    `}
    ${props => props.mh && `
      min-height: ${props.mh};
    `}
  }
  > div {
    width: auto;
  }
`

const InputWrapper = styled.div`
  flex: 1;
  padding: 0px 20px;
  div {
    margin-bottom: 10px;
  }
  ${props => props.mt && `
    margin-top: ${props.mt}
  `}
`

const InputWrapperNew = styled.div`
  flex: 1;
  padding: 0px 20px;

  ${props => props.mt && `
    margin-top: ${props.mt}
  `}

  > div {
    margin-bottom: 10px;
  }
`

const BlockDiv = styled.div`
  display: flex;
  justify-content: space-between;
  ${props => props.mt && `
    margin-top: ${props.mt}
  `}
`

const tableCellStyle = {
  display: "table-cell",
  padding: "10px",
  border: "1px solid black",
}

const DEFAULT_TEAM = {
  name: "",
  members: [],
}

const Wrap = styled.div`
  margin: 0px 40px;
`

const AgentRow = styled.div`
  padding: 15px 25px;
  background: #F1EEFF;
  margin-bottom: 10px;
  border-radius: 10px;
  max-width: 500px;
  display: flex;
  > div {
    &:nth-child(1) {
      flex: 1;
    }
    &:nth-child(2) {
      width: 100px;
    }

  }
`

const Header = styled.div`
  display: flex;
  margin-top: 30px;
  > h1 {
    flex: 1;
  }
`

const ControlsWrap = styled.div`
  width: 250px;
  display: flex;
  justify-content: space-around;
  align-self: flex-start;
`

const TeamMemberInput = styled(Input)`
  padding: 10px 20px;
  width: 500px;
  font-size: 18px;
  margin-bottom: 20px;
`

const InlineFieldRow = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
`

const InlineFieldRowTight = styled(InlineFieldRow)`
  flex-wrap: nowrap;
  overflow-x: auto;
  padding-bottom: 12px;
`

const InlineFieldGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

const InlineFieldLabel = styled.span`
  font-size: 16px;
  color: #333;
`

const SuffixText = styled.span`
  color: #6b778c;
  font-size: 16px;
`

const AgentRadiusFeeAction = styled(Button)`
  padding-left: 0;
`

const ModalLabel = styled.div`
  color: #6b778c;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  margin-bottom: 10px;
  text-transform: uppercase;
`

const ModalSection = styled.div`
  margin-bottom: 22px;
`

const RadiusFeeSummaryAction = styled(Button)`
  padding-left: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
`

const RadiusFeeAddButton = styled(Button)`
  border-radius: 999px;
`

const RepresentationChipWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`

const RepresentationChip = styled(Button)`
  border-radius: 999px;
  min-width: 110px;
  height: auto;
  padding: 6px 18px;
  font-weight: 500;
`

const TeamFeeRepresentationGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
`

const TeamFeeRepresentationChip = styled(Button)`
  width: 100%;
  height: 48px;
  border-radius: 12px;
  padding: 0 16px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`

const TeamFeeOptionHint = styled.div`
  color: #98a2b3;
  font-size: 13px;
  margin-top: 10px;
`

const TeamFeeTierHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 40px;
  gap: 10px;
  margin-bottom: 10px;
  color: #6b778c;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
`

const FeeListCard = styled.div`
  border: 1px solid #e8edf5;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
`

const FeeListHeader = styled.div`
  display: grid;
  grid-template-columns: 1.4fr 0.8fr 0.7fr;
  gap: 16px;
  padding: 14px 18px;
  color: #6b778c;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  background: #fafcff;
`

const FeeListRow = styled.div`
  display: grid;
  grid-template-columns: 1.4fr 0.8fr 0.7fr;
  gap: 16px;
  padding: 14px 18px;
  border-top: 1px solid #edf1f7;
  align-items: center;
`

const FeeListActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const TeamFeeListHeader = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1fr 0.8fr 0.7fr;
  gap: 16px;
  padding: 14px 18px;
  color: #6b778c;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  background: #fafcff;
`

const TeamFeeListRow = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1fr 0.8fr 0.7fr;
  gap: 16px;
  padding: 14px 18px;
  border-top: 1px solid #edf1f7;
  align-items: center;
`

const ModalGridTwo = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
`

const ModalGridThree = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;
`

const TeamFeeTierWrap = styled.div`
  border: 1px solid #e8edf5;
  border-radius: 12px;
  padding: 18px;
  background: #fafcff;
`

const TeamFeeTierRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 40px;
  gap: 10px;
  margin-bottom: 10px;
  align-items: center;
`

const TeamFeeTierLimitGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 12px;
`

const TeamFeeTierLimitRow = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 8px;
`

const TeamFeeTierHint = styled.div`
  color: #98a2b3;
  font-size: 12px;
  line-height: 18px;
  margin-top: 12px;
`

const FeeListContainer = styled.div`
  margin-top: 14px;
  max-width: 1060px;
`

const RADIUS_REPRESENTATION_TYPES = ["buyer", "seller", "tenant", "landlord", "referral"]
const TEAM_FEE_NAME_OPTIONS = [
  { value: "radius_fee", label: "Radius Fee" },
  { value: "audit_fee", label: "Audit Fee" },
  { value: "other_fee", label: "Other Fee" },
]
const TEAM_FEE_TYPE_OPTIONS = [
  { value: "flat", label: "Flat Fee" },
  { value: "percentage", label: "Percentage (Gross commission after deductions)" },
]
const TEAM_FEE_PAYER_OPTIONS = [
  { value: "team", label: "Team" },
  { value: "agent", label: "Agent" },
]
const TEAM_FEE_SPLIT_OPTIONS = [
  { value: "split_equally", label: "Split equally" },
  { value: "each_agent_pays", label: "Each agent pays" },
  { value: "split_by_allocation", label: "Split by allocation" },
]

const defaultTeamFeeTier = (order = 1) => ({
  id: `${Date.now()}-blink-team-fee-tier-${order}`,
  range_from: order === 1 ? 0 : null,
  range_to: null,
  percentage: 0,
})

// ---- Post-Cap Fee constants ----
// Backend enums. NOTE: in the PUT body the kind is sent as `fee_type`
// ("radius_fee" | "audit_fee"); in responses the kind comes back as
// `radius_fee_kind` while `fee_type` means the shape ("flat" | "percentage").
const POST_CAP_FEE_TYPES = ["radius_fee", "audit_fee"]
const POST_CAP_FEE_TYPE_LABELS = { radius_fee: "Radius Fee", audit_fee: "Audit Fee" }
const POST_CAP_FEE_PAYER_LABELS = { team: "Team", agent: "Agent" }
// The modal has no representation picker, so a post-cap plan applies to every
// representation type. Rows returned per representation are grouped back into a
// single logical plan per fee kind for display.
const POST_CAP_ALL_REPRESENTATION_TYPES = ["seller", "buyer", "landlord", "tenant", "referral"]
// Backend cap_collection_mode only supports "remaining_only" | "full".
// "higher" is a design-only option mapped to "full" on save (flag for product).
const POST_CAP_DEAL_BEHAVIOR_OPTIONS = [
  { value: "remaining_only", label: "Collect remaining cap balance only" },
  { value: "full", label: "Always collect full post-cap fee" },
  { value: "higher", label: "Whichever is higher" },
]
const mapPostCapCapMode = (dealBehavior) => (dealBehavior === "higher" ? "full" : dealBehavior)

const PostCapListHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 0.8fr 0.7fr 0.7fr;
  gap: 16px;
  padding: 14px 18px;
  color: #6b778c;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  background: #fafcff;
`

const PostCapListRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 0.8fr 0.7fr 0.7fr;
  gap: 16px;
  padding: 14px 18px;
  border-top: 1px solid #edf1f7;
  align-items: center;
`

const PostCapFieldLabel = styled.div`
  color: #344054;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
`

const PostCapModalSubtitle = styled.div`
  color: #98a2b3;
  font-size: 14px;
  margin-top: 4px;
`

const ImageContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  button {
   top: 10px;
   height: 30px;
   position: relative;
   left: 50px;
  }
`

const ImageUploaderContainer = styled.div`
  display: flex;
  align-items: center;
  .fileUploader {
    width: 30%;
    .fileContainer {
      text-align: center;
      box-shadow: none;
      margin: 0;
      padding: 0;
    }
  }
  // img {
  //   width: 200px;
  //   height: 100px;
  // }
`

const TeamLeadImageUploaderContainer = styled.div`
  display: flex;
  align-items: center;
  .fileContainer {
    width: 20%;
    text-align: center;
    margin-left: 30px;
    box-shadow: none;
  }

  img {
    width: 150px;
    height: 150px;
  }
`

const StyledDiv = styled.div`
  width: 500px;
  padding: 1px 0px 0px 5px;
  cursor: pointer;

  &:hover {
    background-color: aliceblue;
  }
`

const ButtonWrap = styled.div`
  display: flex;
  button {
    margin: 0 40px 0 0;
  }
`

const RequiredWrap = styled.span`
  color: #ED1616;
  font-size: 15px;
  margin-right: 5px;
`

const Label = styled.span`
  margin-left: 5px;
`

const CloseCircleTwoToneIcon = styled(CloseCircleTwoTone)`
  margin-top: -10px;
  position: absolute;
  top: 0;
  font-size: 25px;
  cursor: pointer;
  margin-left: -14px;
`

const ImageWrapper = styled.div`
  display: inline-block;
  position: relative;
`
const STATE_OPTIONS = Object.keys(US_STATES).map(key => ({ label: US_STATES[key], value: US_STATES[key] }))

class BrokerageTeam extends Component {
  state = {
    view: "create",
    name: null,
    iconUrl: null,
    apiCallActive: false,
    showModal: false,
    agentSearchText: null,
    members: [],
    searchResults: [],
    currentSelectedAgent: null,
    apiCallActive: false,
    id: null,
    pictures: [],
    teamLeadPictures: [],
    imageLoading: false,
    adminImageUrl: null,
    city: "",
    state: "",
    productionVolume: "",
    visibleOnLandingPage: false,
    showJobCreateModal: false,
    viewJobModal: false,
    about_team: "",
    other_benefits: "",
    teamInfoLoading: false,
    profile_name: "",
    tcFullName: "",
    tcEmail: "",
    is_cashback_supported: false,
    hide_radius_logo: false,
    brand_primary_color: "",
    brand_background_color: "",
    mobile_theme_light_color: "",
    mobile_theme_dark_color: "",
    primary_sale_representative: "",
    secondary_sale_representative: "",
    primary_sale_representative_split_percentage: "",
    secondary_sale_representative_split_percentage: "",
    past_brokerage_name: "",
    inviteType: 1,
    isNewUserType: false,
    newUserRole: null,
    teamSplit: '',
    teamCap: '',
    radiusCap: '',
    internalCap: '',
    internalCapResetDate: null,
    internal_cap_reset_date: null,
    capResetDates: {}, // Store reset dates for each agent by ID
    radiusFeePaidBy: "agent",
    radiusFeeType: "flat",
    radiusFeeAmount: "",
    radiusFeePercentage: "",
    savedRadiusFeePaidBy: "agent",
    savedRadiusFeeType: "flat",
    savedRadiusFeeAmount: "",
    savedRadiusFeePercentage: "",
    cdaType: "full_transparency",
    cdaSettings: "cda",
    teamRadiusFees: [],
    expandedTeamRadiusFees: false,
    teamFees: [],
    expandedTeamFees: false,
    agentRadiusFeesByAgentId: {},
    agentTeamFeesByAgentId: {},
    expandedAgentFeeRows: {},
    expandedAgentRadiusFeeRows: {},
    expandedAgentTeamFeeRows: {},
    showAgentRadiusFeeModal: false,
    radiusFeeModalScope: "agent",
    radiusFeeModalMode: "add",
    selectedAgentRadiusFee: null,
    radiusFeeModalRepresentations: [],
    radiusFeeModalLockedRepresentations: [],
    radiusFeeModalAvailableTypes: [],
    agentRadiusFeePaidBy: "agent",
    agentRadiusFeeType: "flat",
    agentRadiusFeeAmount: "",
    agentRadiusFeePercentage: "",
    showTeamFeeModal: false,
    teamFeeModalScope: "team",
    teamFeeModalMode: "add",
    selectedAgentTeamFee: null,
    selectedTeamFeeRecord: null,
    teamFeeForm: {
      feeNameType: undefined,
      customFeeName: "",
      representationTypes: [],
      pricingModel: "flat",
      amount: "",
      percentage: "",
      deductionTiming: "post-split",
      paidBy: "team",
      coAgentSplit: "split_equally",
      payableTo: "radius",
      payableName: "Radius",
      usesSlidingScale: false,
      countsTowardCap: false,
    },
    isSavingTeamFee: false,
    // ---- Post-Cap Fee state (local only for now; APIs to be wired later) ----
    teamPostCapFees: [],
    expandedTeamPostCapFees: false,
    agentPostCapFeesByAgentId: {},
    showPostCapFeeModal: false,
    postCapFeeModalScope: "team",
    postCapFeeModalMode: "add",
    selectedPostCapAgent: null,
    postCapEditingKind: null,
    postCapEditingRows: [],
    postCapSetAsTeamCap: false,
    postCapDealBehavior: "remaining_only",
    postCapFeeType: "radius_fee",
    postCapFeePayer: "team",
    postCapAmount: "",
    isSavingPostCapFee: false,
  }

  // Function to format role names for display
  labelRole = (role) => {
    console.log("rolenoo", role)
    if (!role) return '';
    
    const roleMap = {
      'referral_agent': 'Referral Agent',
      'admin_agent': 'Admin Agent', 
      'operation_agent': 'Operations Agent',
      'team_lead': 'Team Lead',
      'co_team_lead': 'Co Team Lead',
      'individual_agent': 'Individual Agent'
    };
    
    return roleMap[role] || role.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  }

  canShowCdaConfirmationToggle = (record) => {
    return Boolean(record?.show_cda_confirm_toggle)
  }

  getCdaConfirmationValue = (record) => {
    return Boolean(record?.can_confirm_cda_breakdown)
  }

  formatDecimalValue = (value) => {
    if (value === "" || value === null || value === undefined) return ""
    const numericValue = Number(value)
    if (Number.isNaN(numericValue)) return value
    return numericValue.toFixed(2)
  }

  isRadiusFeeDirty = () => {
    return (
      this.state.radiusFeePaidBy !== this.state.savedRadiusFeePaidBy
      || this.state.radiusFeeType !== this.state.savedRadiusFeeType
      || this.state.radiusFeeAmount !== this.state.savedRadiusFeeAmount
      || this.state.radiusFeePercentage !== this.state.savedRadiusFeePercentage
    )
  }

  getRepresentationTypeLabel = (type) => {
    const labels = {
      buyer: "Buyer",
      seller: "Seller",
      tenant: "Tenant",
      landlord: "Landlord",
      referral: "Referral",
    }

    return labels[type] || type
  }

  getRadiusFeeAmountLabel = (fee) => {
    const feeType = fee && fee.fee_type
    const amount = fee && fee.amount
    const percentage = fee && fee.percentage !== null && fee.percentage !== undefined
      ? fee.percentage
      : amount

    if (feeType === "percentage") {
      if (percentage === null || percentage === undefined || percentage === "") return "-"
      return `${this.formatDecimalValue(percentage)}%`
    }

    if (feeType === "both") {
      const amountLabel = amount === null || amount === undefined || amount === ""
        ? "-"
        : `$${this.formatDecimalValue(amount)}`
      const percentageLabel = percentage === null || percentage === undefined || percentage === ""
        ? "-"
        : `${this.formatDecimalValue(percentage)}%`
      return `${amountLabel} + ${percentageLabel}`
    }

    if (amount === null || amount === undefined || amount === "") return "-"
    return `$${this.formatDecimalValue(amount)}`
  }

  sortRadiusFees = (fees = []) => {
    return [...fees].sort((a, b) => (
      RADIUS_REPRESENTATION_TYPES.indexOf(a && a.representation_type)
      - RADIUS_REPRESENTATION_TYPES.indexOf(b && b.representation_type)
    ))
  }

  getUsedRepresentationTypes = (fees = []) => {
    return new Set(
      fees
        .map((fee) => fee && fee.representation_type)
        .filter(Boolean)
    )
  }

  getAvailableRepresentationTypes = (fees = []) => {
    const usedTypes = this.getUsedRepresentationTypes(fees)
    return RADIUS_REPRESENTATION_TYPES.filter(type => !usedTypes.has(type))
  }

  getTeamFeeResponseList = (data) => {
    if (!(data && data.response)) return []
    const list = data.response.team_fees
      || data.response.radius_fees
      || data.response.team_level_radius_fees
      || data.response.agent_team_level_radius_fees
      || data.response.agent_team_fees
      || data.response.fees
      || []
    return Array.isArray(list) ? list : []
  }

  getTeamFeeRepresentationTypes = (fee) => {
    if (!fee) return []
    const representationTypes = fee.representation_types
    if (Array.isArray(representationTypes) && representationTypes.length) {
      return representationTypes.filter(Boolean)
    }
    if (typeof representationTypes === "string" && representationTypes.trim()) {
      return representationTypes.split(",").map(type => type.trim()).filter(Boolean)
    }
    if (fee.representation_type) {
      return [fee.representation_type]
    }
    return []
  }

  getTeamFeeNameType = (fee) => {
    const name = String(
      (fee && (fee.fee_name || fee.name || fee.label || fee.display_name)) || ""
    ).trim()
    const normalized = name.toLowerCase()

    if (normalized === "radius fee") return "radius_fee"
    if (normalized === "audit fee") return "audit_fee"
    if (normalized === "other fee") return "other_fee"

    return name ? "other_fee" : undefined
  }

  getTeamFeeDisplayName = (fee) => {
    const feeNameType = this.getTeamFeeNameType(fee)
    if (feeNameType === "radius_fee") return "Radius Fee"
    if (feeNameType === "audit_fee") return "Audit Fee"

    return (fee && (fee.fee_name || fee.name || fee.label || fee.display_name)) || "Other Fee"
  }

  getTeamFeeAmountLabel = (fee) => {
    const pricingModel = (fee && (fee.pricing_model || fee.fee_type)) || "flat"
    const amount = fee && fee.amount
    const percentage = fee && fee.percentage
    const isSlidingScale = Boolean(fee && (fee.uses_sliding_scale || fee.sliding_scale))

    if (isSlidingScale) {
      return "Sliding scale"
    }

    if (pricingModel === "percentage") {
      const percentageValue = percentage === null || percentage === undefined || percentage === ""
        ? amount
        : percentage
      if (percentageValue === null || percentageValue === undefined || percentageValue === "") return "-"
      return `${this.formatDecimalValue(percentageValue)}%`
    }

    if (amount === null || amount === undefined || amount === "") return "-"
    return `$${this.formatDecimalValue(amount)}`
  }

  getDefaultTeamFeeForm = () => ({
    feeNameType: undefined,
    customFeeName: "",
    representationTypes: [],
    pricingModel: "flat",
    amount: "",
    percentage: "",
    percentageBasis: "gross-commission-after-deduction",
    deductionTiming: "post-split",
    paidBy: "team",
    coAgentSplit: "split_equally",
    payableTo: "radius",
    payableName: "Radius",
    usesSlidingScale: false,
    slidingScaleTiers: [defaultTeamFeeTier(1)],
    notLessThanEnabled: false,
    notLessThanAmount: "",
    notToExceedEnabled: false,
    notToExceedAmount: "",
    countsTowardCap: false,
  })

  getTeamFeeModalForm = (fee = null) => {
    const defaultForm = this.getDefaultTeamFeeForm()

    if (!fee) return defaultForm

    const feeNameType = this.getTeamFeeNameType(fee)
    const displayName = this.getTeamFeeDisplayName(fee)
    const amount = fee && fee.amount
    const pricingModel = (fee && (fee.pricing_model || fee.fee_type)) || "flat"
    const percentage = fee && fee.percentage

    return {
      ...defaultForm,
      feeNameType,
      customFeeName: feeNameType === "other_fee" ? displayName : "",
      representationTypes: this.getTeamFeeRepresentationTypes(fee),
      pricingModel,
      amount: amount === null || amount === undefined ? "" : this.formatDecimalValue(amount),
      percentage: pricingModel === "percentage"
        ? this.formatDecimalValue(
          percentage === null || percentage === undefined ? amount : percentage
        )
        : (percentage === null || percentage === undefined ? "" : this.formatDecimalValue(percentage)),
      percentageBasis: (fee && fee.percentage_basis) || "gross-commission-after-deduction",
      deductionTiming: "post-split",
      paidBy: (fee && (fee.paid_by || fee.fee_payer || fee.payer)) || "team",
      coAgentSplit: (fee && (fee.co_agent_split || fee.split_type)) || "split_equally",
      payableTo: "radius",
      payableName: "Radius",
      usesSlidingScale: Boolean(fee && (fee.uses_sliding_scale || fee.sliding_scale)),
      slidingScaleTiers:
        Array.isArray(fee && fee.tiers) && fee.tiers.length
          ? fee.tiers.map((tier, idx) => ({
            id: `${Date.now()}-blink-team-fee-tier-${idx + 1}`,
            range_from: idx === 0 ? 0 : (tier && tier.range_start),
            range_to: tier && tier.range_end,
            percentage: tier && tier.fee_value,
          }))
          : [defaultTeamFeeTier(1)],
      notLessThanEnabled: Boolean(fee && fee.not_less_than_enabled),
      notLessThanAmount:
        fee && fee.not_less_than_amount !== null && fee.not_less_than_amount !== undefined
          ? this.formatDecimalValue(fee.not_less_than_amount)
          : "",
      notToExceedEnabled: Boolean(fee && fee.not_to_exceed_enabled),
      notToExceedAmount:
        fee && fee.not_to_exceed_amount !== null && fee.not_to_exceed_amount !== undefined
          ? this.formatDecimalValue(fee.not_to_exceed_amount)
          : "",
      countsTowardCap: feeNameType === "radius_fee"
        ? true
        : Boolean(fee && (fee.contributes_to_radius_cap || fee.counts_toward_cap || fee.counts_toward_agent_cap)),
    }
  }

  fetchTeamRadiusFees = async (teamId) => {
    try {
      const response = await fetch(`${baseUrl}/v1.0/brokerage-team/radius-fees?team_id=${teamId}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "internal-id": token,
        },
      })
      const data = await response.json()
      return (data && data.response && data.response.radius_fees) || []
    } catch (error) {
      console.error("Error fetching team radius fees:", error)
      return []
    }
  }

  fetchAgentRadiusFees = async (teamId, agentId) => {
    try {
      const response = await fetch(`${baseUrl}/v1.0/brokerage-team/agent-radius-fees?team_id=${teamId}&agent_id=${agentId}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "internal-id": token,
        },
      })
      const data = await response.json()
      return (data && data.response && data.response.radius_fees) || []
    } catch (error) {
      console.error("Error fetching agent radius fees:", error)
      return []
    }
  }

  // Build an agentId -> fees[] map from the inline fee arrays now returned on
  // each members[] object by brokerage-teams?id=. This replaces the old
  // per-agent fetch loops (agent-radius-fees / agent-post-cap-radius-fees) that
  // fired one request per member. The single-agent fetchers are still used to
  // refresh a single row after an edit/save from the modals.
  buildAgentFeeMapFromMembers = (members = [], field) => {
    const list = Array.isArray(members) ? members : []
    return list.reduce((acc, member) => {
      if (!member || member.id === null || member.id === undefined) return acc
      const fees = member[field]
      acc[member.id] = Array.isArray(fees) ? fees : []
      return acc
    }, {})
  }

  fetchTeamFees = async (teamId) => {
    try {
      const response = await fetch(`${baseUrl}/v1.0/brokerage-team/team-level-radius-fees?team_id=${teamId}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "internal-id": token,
          "X-User-Agent": "agent-php",
        },
      })
      const data = await response.json()
      return this.getTeamFeeResponseList(data)
    } catch (error) {
      console.error("Error fetching team fees:", error)
      return []
    }
  }

  fetchAgentTeamFees = async (teamId, agentId) => {
    try {
      const response = await fetch(`${baseUrl}/v1.0/brokerage-team/agent-team-level-radius-fees?team_id=${teamId}&agent_id=${agentId}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "internal-id": token,
          "X-User-Agent": "agent-php",
        },
      })
      const data = await response.json()
      return this.getTeamFeeResponseList(data)
    } catch (error) {
      console.error("Error fetching agent team fees:", error)
      return []
    }
  }

  fetchAllAgentTeamFees = async (teamId, members = []) => {
    const entries = await Promise.all(
      (members || []).map(async (member) => ([
        member.id,
        await this.fetchAgentTeamFees(teamId, member.id),
      ]))
    )

    return entries.reduce((acc, [agentId, fees]) => {
      acc[agentId] = fees
      return acc
    }, {})
  }
  // ================= Post-Cap Fee fetchers =================
  parsePostCapFeesResponse = (data) => (
    (data && data.response && data.response.post_cap_radius_fees)
    || (data && data.post_cap_radius_fees)
    || []
  )

  fetchTeamPostCapFees = async (teamId) => {
    try {
      const response = await fetch(`${baseUrl}/v1.0/brokerage-team/post-cap-radius-fees?team_id=${teamId}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "internal-id": token,
        },
      })
      const data = await response.json()
      return this.parsePostCapFeesResponse(data)
    } catch (error) {
      console.error("Error fetching team post-cap fees:", error)
      return []
    }
  }

  fetchAgentPostCapFees = async (teamId, agentId) => {
    try {
      const response = await fetch(`${baseUrl}/v1.0/brokerage-team/agent-post-cap-radius-fees?team_id=${teamId}&agent_id=${agentId}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "internal-id": token,
        },
      })
      const data = await response.json()
      return this.parsePostCapFeesResponse(data)
    } catch (error) {
      console.error("Error fetching agent post-cap fees:", error)
      return []
    }
  }
  openTeamRadiusFeeModal = (group = null) => {
    const rawFees = this.state.teamRadiusFees || []
    const availableTypes = this.getAvailableRepresentationTypes(rawFees)
    const selectedRepresentations = group && group.representation_type ? [group.representation_type] : []
    const modalAvailableTypes = group ? [...selectedRepresentations] : availableTypes

    this.setState({
      showAgentRadiusFeeModal: true,
      radiusFeeModalScope: "team",
      radiusFeeModalMode: group ? "edit" : "add",
      selectedAgentRadiusFee: null,
      radiusFeeModalRepresentations: group ? [...selectedRepresentations] : [],
      radiusFeeModalLockedRepresentations: [],
      agentRadiusFeePaidBy: (group && group.paid_by) || "agent",
      agentRadiusFeeType: (group && group.fee_type) || "flat",
      agentRadiusFeeAmount: group ? this.formatDecimalValue(group && group.amount) : "",
      agentRadiusFeePercentage: group
        ? this.formatDecimalValue(group && (group.percentage !== undefined && group.percentage !== null ? group.percentage : group.amount))
        : "",
      radiusFeeModalAvailableTypes: modalAvailableTypes,
    })
  }

  openAgentRadiusFeeModal = (record, group = null) => {
    const fallbackPaidBy = "agent"
    const fallbackType = "flat"
    const rawFees = (this.state.agentRadiusFeesByAgentId && this.state.agentRadiusFeesByAgentId[record.id]) || []
    const availableTypes = this.getAvailableRepresentationTypes(rawFees)
    const selectedRepresentations = group && group.representation_type ? [group.representation_type] : []
    const modalAvailableTypes = group ? [...selectedRepresentations] : availableTypes

    this.setState({
      showAgentRadiusFeeModal: true,
      radiusFeeModalScope: "agent",
      radiusFeeModalMode: group ? "edit" : "add",
      selectedAgentRadiusFee: record,
      radiusFeeModalRepresentations: group ? [...selectedRepresentations] : [],
      radiusFeeModalLockedRepresentations: [],
      agentRadiusFeePaidBy: (group && group.paid_by) || fallbackPaidBy,
      agentRadiusFeeType: (group && group.fee_type) || fallbackType,
      agentRadiusFeeAmount: group ? this.formatDecimalValue(group && group.amount) : "",
      agentRadiusFeePercentage: group
        ? this.formatDecimalValue(group && (group.percentage !== undefined && group.percentage !== null ? group.percentage : group.amount))
        : "",
      radiusFeeModalAvailableTypes: modalAvailableTypes,
    })
  }

  toggleRadiusFeeRepresentation = (representationType) => {
    if (this.isRadiusFeeRepresentationDisabled(representationType)) return

    const current = this.state.radiusFeeModalRepresentations || []
    const next = current.includes(representationType)
      ? current.filter(type => type !== representationType)
      : [...current, representationType]

    this.setState({
      radiusFeeModalRepresentations: next,
    })
  }

  isRadiusFeeRepresentationDisabled = (representationType) => {
    const { radiusFeeModalAvailableTypes = [] } = this.state
    return !radiusFeeModalAvailableTypes.includes(representationType)
  }

  closeAgentRadiusFeeModal = () => {
    this.setState({
      showAgentRadiusFeeModal: false,
      radiusFeeModalScope: "agent",
      radiusFeeModalMode: "add",
      selectedAgentRadiusFee: null,
      radiusFeeModalRepresentations: [],
      radiusFeeModalLockedRepresentations: [],
      radiusFeeModalAvailableTypes: [],
      agentRadiusFeePaidBy: "agent",
      agentRadiusFeeType: "flat",
      agentRadiusFeeAmount: "",
      agentRadiusFeePercentage: "",
      isSavingAgentRadiusFee: false,
    })
  }

  openTeamFeeModal = ({ scope = "team", record = null, fee = null } = {}) => {
    this.setState({
      showTeamFeeModal: true,
      teamFeeModalScope: scope,
      teamFeeModalMode: fee ? "edit" : "add",
      selectedAgentTeamFee: record,
      selectedTeamFeeRecord: fee,
      teamFeeForm: this.getTeamFeeModalForm(fee),
    })
  }

  closeTeamFeeModal = () => {
    this.setState({
      showTeamFeeModal: false,
      teamFeeModalScope: "team",
      teamFeeModalMode: "add",
      selectedAgentTeamFee: null,
      selectedTeamFeeRecord: null,
      teamFeeForm: this.getDefaultTeamFeeForm(),
      isSavingTeamFee: false,
    })
  }

  updateTeamFeeForm = (updates) => {
    this.setState((prevState) => ({
      teamFeeForm: {
        ...prevState.teamFeeForm,
        ...updates,
      },
    }))
  }

  toggleTeamFeeRepresentationType = (representationType) => {
    const currentTypes = Array.isArray(this.state.teamFeeForm && this.state.teamFeeForm.representationTypes)
      ? this.state.teamFeeForm.representationTypes
      : []
    const nextTypes = currentTypes.includes(representationType)
      ? currentTypes.filter(type => type !== representationType)
      : [...currentTypes, representationType]

    this.updateTeamFeeForm({ representationTypes: nextTypes })
  }

  updateTeamFeeTier = (tierId, key, value) => {
    this.setState((prevState) => {
      const currentForm = prevState.teamFeeForm || this.getDefaultTeamFeeForm()
      return {
        teamFeeForm: {
          ...currentForm,
          slidingScaleTiers: (currentForm.slidingScaleTiers || []).map((tier) => {
            if (tier.id !== tierId) return tier
            return {
              ...tier,
              [key]: value,
            }
          }),
        },
      }
    })
  }

  addTeamFeeTier = () => {
    this.setState((prevState) => {
      const currentForm = prevState.teamFeeForm || this.getDefaultTeamFeeForm()
      const existingTiers = Array.isArray(currentForm.slidingScaleTiers) ? currentForm.slidingScaleTiers : []

      if (!existingTiers.length) {
        return {
          teamFeeForm: {
            ...currentForm,
            slidingScaleTiers: [defaultTeamFeeTier(1)],
          },
        }
      }

      const previousTier = existingTiers[existingTiers.length - 1]
      const inheritedRangeFrom = previousTier && previousTier.range_to
      if (inheritedRangeFrom === null || inheritedRangeFrom === undefined || inheritedRangeFrom === "") {
        return null
      }

      return {
        teamFeeForm: {
          ...currentForm,
          slidingScaleTiers: [
            ...existingTiers,
            {
              ...defaultTeamFeeTier(existingTiers.length + 1),
              range_from: inheritedRangeFrom,
            },
          ],
        },
      }
    })
  }

  removeTeamFeeTier = (tierId) => {
    this.setState((prevState) => {
      const currentForm = prevState.teamFeeForm || this.getDefaultTeamFeeForm()
      const remainingTiers = (currentForm.slidingScaleTiers || []).filter((tier) => tier.id !== tierId)

      return {
        teamFeeForm: {
          ...currentForm,
          slidingScaleTiers: remainingTiers.length
            ? remainingTiers.map((tier, index) => ({
              ...tier,
              range_from: index === 0 ? 0 : tier.range_from,
            }))
            : [defaultTeamFeeTier(1)],
        },
      }
    })
  }

  canAddTeamFeeTier = () => {
    const teamFeeForm = this.state.teamFeeForm || this.getDefaultTeamFeeForm()
    const tiers = Array.isArray(teamFeeForm.slidingScaleTiers) ? teamFeeForm.slidingScaleTiers : []
    if (!tiers.length) return true
    const lastTier = tiers[tiers.length - 1] || {}
    return !(lastTier.range_to === null || lastTier.range_to === undefined || lastTier.range_to === "")
  }

  getTeamFeeTierValidationErrors = (teamFeeForm) => {
    const errors = []
    const tiers = Array.isArray(teamFeeForm && teamFeeForm.slidingScaleTiers)
      ? teamFeeForm.slidingScaleTiers
      : []

    if (!tiers.length) {
      errors.push("At least one tier is required")
      return errors
    }

    tiers.forEach((tier, index) => {
      const fromValue = tier && tier.range_from !== "" ? Number(tier.range_from) : null
      const toValue = tier && tier.range_to !== "" ? Number(tier.range_to) : null
      const tierValue = tier && tier.percentage !== "" ? Number(tier.percentage) : null
      const previousToValue = index > 0
        ? (
          tiers[index - 1] && tiers[index - 1].range_to !== ""
            ? Number(tiers[index - 1].range_to)
            : null
        )
        : null

      if (index === 0 && fromValue !== 0) {
        errors.push("First tier Over value must start at 0")
      }
      if (index > 0 && previousToValue !== null && fromValue !== previousToValue) {
        errors.push("Each tier Over value must match the previous Up to value")
      }
      if (fromValue === null || Number.isNaN(fromValue)) {
        errors.push(`Tier ${index + 1}: Over value is required`)
      }
      if (toValue === null || Number.isNaN(toValue)) {
        errors.push(`Tier ${index + 1}: Up to value is required`)
      }
      if (fromValue !== null && toValue !== null && !Number.isNaN(fromValue) && !Number.isNaN(toValue) && toValue < fromValue) {
        errors.push(`Tier ${index + 1}: Up to value must be greater than or equal to Over value`)
      }
      if (tierValue === null || Number.isNaN(tierValue) || tierValue <= 0) {
        errors.push(`Tier ${index + 1}: amount is required`)
      }
    })

    if (teamFeeForm && teamFeeForm.pricingModel === "percentage") {
      const minimumValue = teamFeeForm.notLessThanEnabled && teamFeeForm.notLessThanAmount !== ""
        ? Number(teamFeeForm.notLessThanAmount)
        : null
      const maximumValue = teamFeeForm.notToExceedEnabled && teamFeeForm.notToExceedAmount !== ""
        ? Number(teamFeeForm.notToExceedAmount)
        : null

      if (teamFeeForm.notLessThanEnabled && (minimumValue === null || Number.isNaN(minimumValue))) {
        errors.push("Not less than amount is required")
      }
      if (teamFeeForm.notToExceedEnabled && (maximumValue === null || Number.isNaN(maximumValue))) {
        errors.push("Not to exceed amount is required")
      }
      if (minimumValue !== null && maximumValue !== null && minimumValue > maximumValue) {
        errors.push("Not less than amount cannot be greater than not to exceed amount")
      }
    }

    return errors
  }

  saveTeamFeeModal = async () => {
    try {
      const {
        id: teamId,
        teamFeeModalScope,
        selectedAgentTeamFee,
        selectedTeamFeeRecord,
        teamFeeForm,
      } = this.state
      const currentForm = teamFeeForm || this.getDefaultTeamFeeForm()

      if (!teamId) {
        message.info("Please save the team first before updating the team fee")
        return
      }

      if (teamFeeModalScope === "agent" && !(selectedAgentTeamFee && selectedAgentTeamFee.id)) {
        message.info("Please select an agent before updating the team fee")
        return
      }

      if (!currentForm.feeNameType) {
        message.error("Please select a fee name")
        return
      }

      if (currentForm.feeNameType === "other_fee" && !String(currentForm.customFeeName || "").trim()) {
        message.error("Please enter a fee name")
        return
      }

      if (!currentForm.representationTypes || currentForm.representationTypes.length === 0) {
        message.error("Please select at least one representation type")
        return
      }

      const numericAmount = currentForm.amount === "" ? null : Number(currentForm.amount)
      const numericPercentage = currentForm.percentage === "" ? null : Number(currentForm.percentage)
      const usesAmount = currentForm.pricingModel === "flat"
      const usesPercentage = currentForm.pricingModel === "percentage"

      if (!currentForm.usesSlidingScale && usesAmount && (numericAmount === null || Number.isNaN(numericAmount))) {
        message.error("Please enter a valid flat fee amount")
        return
      }

      if (!currentForm.usesSlidingScale && usesPercentage && (numericPercentage === null || Number.isNaN(numericPercentage))) {
        message.error("Please enter a valid percentage")
        return
      }

      if (currentForm.usesSlidingScale) {
        const tierErrors = this.getTeamFeeTierValidationErrors(currentForm)
        if (tierErrors.length) {
          message.error(tierErrors[0])
          return
        }
      }

      const feeName = currentForm.feeNameType === "other_fee"
        ? String(currentForm.customFeeName || "").trim()
        : ((TEAM_FEE_NAME_OPTIONS.find((option) => option.value === currentForm.feeNameType) || {}).label || "")

      const endpoint = teamFeeModalScope === "team"
        ? `${baseUrl}/v1.0/brokerage-team/team-level-radius-fees`
        : `${baseUrl}/v1.0/brokerage-team/agent-team-level-radius-fees`

      const body = {
        team_id: teamId,
        agent_id: teamFeeModalScope === "agent" ? selectedAgentTeamFee.id : undefined,
        fee_name_type: currentForm.feeNameType,
        name: feeName,
        fee_type: currentForm.pricingModel,
        deduction_timing: "post-split",
        paid_by: currentForm.paidBy,
        co_agent_split: currentForm.coAgentSplit,
        payable_to_type: "radius",
        percentage_basis: "gross-commission-after-deduction",
        uses_sliding_scale: Boolean(currentForm.usesSlidingScale),
        tiers: (currentForm.slidingScaleTiers || [])
          .map((tier, index) => ({
            tier_order: index + 1,
            range_start: tier && tier.range_from !== "" ? Number(tier.range_from) : null,
            range_end: tier && tier.range_to !== "" ? Number(tier.range_to) : null,
            fee_value: tier && tier.percentage !== "" ? Number(tier.percentage) : 0,
          }))
          .filter((tier) => (
            tier.range_start !== null
            && tier.range_end !== null
            && !Number.isNaN(tier.range_start)
            && !Number.isNaN(tier.range_end)
            && tier.fee_value > 0
          )),
        not_less_than_enabled: Boolean(currentForm.notLessThanEnabled),
        not_less_than_amount: currentForm.notLessThanAmount === "" ? 0 : Number(currentForm.notLessThanAmount),
        not_to_exceed_enabled: Boolean(currentForm.notToExceedEnabled),
        not_to_exceed_amount: currentForm.notToExceedAmount === "" ? 0 : Number(currentForm.notToExceedAmount),
        contributes_to_radius_cap: currentForm.feeNameType === "radius_fee"
          ? true
          : Boolean(currentForm.countsTowardCap),
      }

      if ((currentForm.representationTypes || []).length === 1) {
        body.representation_type = currentForm.representationTypes[0]
      } else {
        body.representation_types = currentForm.representationTypes
      }

      if (currentForm.pricingModel === "flat") {
        body.amount = currentForm.usesSlidingScale ? 0 : numericAmount
        body.percentage = null
      } else if (currentForm.pricingModel === "percentage") {
        body.amount = undefined
        body.percentage = currentForm.usesSlidingScale ? 0 : numericPercentage
      } else {
        body.amount = undefined
        body.percentage = currentForm.usesSlidingScale ? 0 : numericPercentage
      }

      this.setState({ isSavingTeamFee: true })

      const response = await fetch(endpoint, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "internal-id": token,
          "X-User-Agent": "agent-php",
        },
        body: JSON.stringify(body),
      })

      const data = await response.json()

      if (!response.ok || (data && data.response && data.response.success === false)) {
        message.error((data && data.error && data.error.message) || "Failed to update team fee")
        this.setState({ isSavingTeamFee: false })
        return
      }

      const hasFeeListInResponse = Boolean(
          data
          && data.response
          && (
            data.response.team_fees
            || data.response.radius_fees
            || data.response.team_level_radius_fees
            || data.response.agent_team_level_radius_fees
            || data.response.agent_team_fees
            || data.response.fees
          )
      )
      const fees = hasFeeListInResponse
        ? this.getTeamFeeResponseList(data)
        : (
          teamFeeModalScope === "team"
            ? await this.fetchTeamFees(teamId)
            : await this.fetchAgentTeamFees(teamId, selectedAgentTeamFee.id)
        )

      if (teamFeeModalScope === "team") {
        this.setState({
          teamFees: fees,
          expandedTeamFees: true,
        })
      } else {
        this.setState((prevState) => ({
          agentTeamFeesByAgentId: {
            ...prevState.agentTeamFeesByAgentId,
            [selectedAgentTeamFee.id]: fees,
          },
          expandedAgentTeamFeeRows: {
            ...prevState.expandedAgentTeamFeeRows,
            [selectedAgentTeamFee.id]: true,
          },
          expandedAgentFeeRows: {
            ...prevState.expandedAgentFeeRows,
            [selectedAgentTeamFee.id]: true,
          },
        }))
      }

      message.success(`${teamFeeModalScope === "team" ? "Team" : "Agent"} fee updated successfully!`)
      this.closeTeamFeeModal()
    } catch (error) {
      console.error("Error updating team fee:", error)
      message.error("Something went wrong. Please try again.")
      this.setState({ isSavingTeamFee: false })
    }
  }

  deleteTeamFeeRecord = ({ scope = "team", record = null, fee = null } = {}) => {
    confirm({
      title: `Delete this ${scope === "team" ? "team" : "agent"} fee?`,
      icon: <ExclamationCircleOutlined />,
      onOk: async () => {
        try {
          const { id: teamId } = this.state
          if (!(teamId && fee)) return
          if (scope === "agent" && !(record && record.id)) return

          const feeName = this.getTeamFeeDisplayName(fee)
          const representationTypes = this.getTeamFeeRepresentationTypes(fee)
          const body = {
            team_id: teamId,
            name: feeName,
            agent_id: scope === "agent" ? record.id : undefined,
          }

          if (representationTypes.length === 1) {
            body.representation_type = representationTypes[0]
          } else if (representationTypes.length > 1) {
            body.representation_types = representationTypes
          }

          const endpoint = scope === "team"
            ? `${baseUrl}/v1.0/brokerage-team/team-level-radius-fees`
            : `${baseUrl}/v1.0/brokerage-team/agent-team-level-radius-fees`

          const response = await fetch(endpoint, {
            method: "DELETE",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              "internal-id": token,
              "X-User-Agent": "agent-php",
            },
            body: JSON.stringify(body),
          })

          const data = await response.json()

          if (!response.ok || (data && data.response && data.response.success === false)) {
            message.error((data && data.error && data.error.message) || "Failed to delete fee")
            return
          }

          const hasFeeListInResponse = Boolean(
            data
            && data.response
            && (
              data.response.team_fees
              || data.response.radius_fees
              || data.response.team_level_radius_fees
              || data.response.agent_team_level_radius_fees
              || data.response.agent_team_fees
              || data.response.fees
            )
          )
          const fees = hasFeeListInResponse
            ? this.getTeamFeeResponseList(data)
            : (
              scope === "team"
                ? await this.fetchTeamFees(teamId)
                : await this.fetchAgentTeamFees(teamId, record.id)
            )

          if (scope === "team") {
            this.setState({
              teamFees: fees,
              expandedTeamFees: fees.length > 0 ? this.state.expandedTeamFees : false,
            })
          } else {
            this.setState((prevState) => ({
              agentTeamFeesByAgentId: {
                ...prevState.agentTeamFeesByAgentId,
                [record.id]: fees,
              },
              expandedAgentTeamFeeRows: {
                ...prevState.expandedAgentTeamFeeRows,
                [record.id]: fees.length > 0
                  ? (prevState.expandedAgentTeamFeeRows && prevState.expandedAgentTeamFeeRows[record.id])
                  : false,
              },
              expandedAgentFeeRows: {
                ...prevState.expandedAgentFeeRows,
                [record.id]: (
                  Boolean(prevState.expandedAgentRadiusFeeRows && prevState.expandedAgentRadiusFeeRows[record.id])
                  || (fees.length > 0
                    ? (prevState.expandedAgentTeamFeeRows && prevState.expandedAgentTeamFeeRows[record.id])
                    : false)
                ),
              },
            }))
          }

          message.success(`${scope === "team" ? "Team" : "Agent"} fee deleted successfully!`)
        } catch (error) {
          console.error("Error deleting team fee:", error)
          message.error("Something went wrong. Please try again.")
        }
      },
    })
  }

  createDefaultTeam = () => {
    const team = DEFAULT_TEAM
    this.setState({ team })
  }

  settcDetails = (name, value) => {
    this.setState({
      [name]: value,
    })
  }

  onDrop = async (picture) => {
    this.setState({
      pictures: this.state.pictures.concat(picture),
      imageLoading: true,
    })
    const fd = new FormData()
    fd.append("imageFile", picture[0])
    const data = {
      filePath: `brokerageTeam/${Math.random().toString(36).replace(/[^a-z]+/g, "").substr(0, 5)}`,
      config: {
        bucket: "broker",
        convertTo: "jpeg",
      },
    }
    fd.append("requestBody", JSON.stringify(data))
    let resp = await fetch(`${baseUrl}/v1.0/image`, {
      method: "POST",
      headers: {
        "internal-id": token,
        "X-User-Agent": "agent-php",
      },
      body: fd,
    })
    resp = await resp.json()
    this.setState({
      iconUrl: resp.response.imageURL,
      pictures: this.state.pictures.concat(picture),
      imageLoading: false,
    })
  }

  onDropTeamLead = async (picture) => {
    this.setState({
      teamLeadPictures: this.state.teamLeadPictures.concat(picture),
      imageLoading: true,
    })
    const fd = new FormData()
    fd.append("imageFile", picture[0])
    const data = {
      filePath: `brokerageTeam/${Math.random().toString(36).replace(/[^a-z]+/g, "").substr(0, 5)}`,
      config: {
        bucket: "broker",
        convertTo: "jpeg",
      },
    }
    fd.append("requestBody", JSON.stringify(data))
    let resp = await fetch(`${baseUrl}/v1.0/image`, {
      method: "POST",
      headers: {
        "internal-id": token,
        "X-User-Agent": "agent-php",
      },
      body: fd,
    })
    resp = await resp.json()
    this.setState({
      adminImageUrl: resp.response.imageURL,
      teamLeadPictures: this.state.teamLeadPictures.concat(picture),
      imageLoading: false,
    })
  }

  removeImage = (type) => {
    this.setState({
      [`${type}Src`]: "",
      [`${type}Url`]: "",
    })
  }

  createReactImageCropReader = (picture, type) => {
    console.log("==picture=====", picture)
    const reader = new FileReader()
    reader.addEventListener(
      "load",
      () => this.setState({
        [`${type}Src`]: reader.result,
        [`${type}EditShow`]: true,
      }),
      false
    )
    reader.readAsDataURL(picture[0])
    this.setState({ type })
  }

  closeImageEdit = (type) => {
    this.setState({
      imageLoading: false,
      [`${type}EditShow`]: false,
    })
  }

  uploadTeamCoverImage = async (picture, type) => {
    // teamCoverImageEditShow
    this.setState({
      teamLeadPictures: this.state.teamLeadPictures.concat(picture),
      imageLoading: true,
    })
    const fd = new FormData()
    fd.append("imageFile", picture)
    const data = {
      filePath: `brokerageTeam/${Math.random().toString(36).replace(/[^a-z]+/g, "").substr(0, 5)}`,
      config: {
        bucket: "broker",
        convertTo: "jpeg",
      },
    }
    fd.append("requestBody", JSON.stringify(data))
    let resp = await fetch(`${baseUrl}/v1.0/image`, {
      method: "POST",
      headers: {
        "internal-id": token,
        "X-User-Agent": "agent-php",
      },
      body: fd,
    })
    resp = await resp.json()
    this.setState({
      [`${type}Url`]: resp.response.imageURL,
      teamLeadPictures: this.state.teamLeadPictures.concat(picture),
      imageLoading: false,
      [`${type}EditShow`]: false,
    })
  }

  getNameDiv = () => {
    const {
      imageLoading,
      teamLeadSrc,
      teamCoverImageSrc,
      teamCoverImageEditShow,
      teamCoverImageUrl,
      teamGalleryImage1Src,
      teamGalleryImage1EditShow,
      teamGalleryImage1Url,
      teamGalleryImage2Src,
      teamGalleryImage2EditShow,
      teamGalleryImage2Url,
      teamGalleryImage3Src,
      teamGalleryImage3EditShow,
      state,
      teamGalleryImage3Url,
      type,
      teamInfoLoading,
      iconSrc,
      iconEditShow,
      iconUrl,
      adminImageEditShow,
      adminImageSrc,
    } = this.state
    console.log("===this.state===..", this.state)
    return (<>
      {teamInfoLoading ? (<Loader />) : (
        <div>
          <BlockDiv>
            <InputWrapper>
              <div>
                <RequiredWrap> * </RequiredWrap>
                Name
              </div>
              <Input value={this.state.name} onChange={e => this.changeTeamName(e.target.value)} />
            </InputWrapper>
            <InputWrapper>
              <div>
                City
              </div>
              <Input value={this.state.city} onChange={e => this.changeTeamCity(e.target.value)} />
            </InputWrapper>
            <InputWrapper>
              <div>
                State
              </div>
              {/* <Input value={this.state.state} onChange={e => this.changeTeamState(e.target.value)} /> */}
              <Select
                onChange={value => this.changeTeamState(value)}
                style={{
                  width: 250,
                }}
                value={state}
              >
                {STATE_OPTIONS.map(st => (
                  <Select.Option value={st.value}>{st.label}</Select.Option>
                ))}
              </Select>
            </InputWrapper>
            <InputWrapper>
              <div>
                Enrolled in Cashback Program?
              </div>
              <Switch
                checked={this.state.is_cashback_supported}
                onChange={(value) => {
                  this.setState({ is_cashback_supported: value })
                }}
              />
            </InputWrapper>
            <InputWrapper>
              <div>
                {/* <RequiredWrap> * </RequiredWrap> */}
              Production Volume
              </div>
              <Input type="number" value={this.state.productionVolume} onChange={e => this.changeTeamProductionVolume(e.target.value)} />
            </InputWrapper>
          </BlockDiv>
          <BlockDiv mt="30px">
            <InputWrapper>
              <div>
                {/* <RequiredWrap> * </RequiredWrap> */}
             Primary Sales Representative
              </div>
              <Select
                placeholder="Select"
                onChange={value => this.changePrimarySalesRepresentative(value)}
                value={this.state.primary_sale_representative}
                style={{
                  width: 200,
                }}
                options={SALES_REPRESENTATIVE}
              />
            </InputWrapper>
            <InputWrapper>
              <div>
                {/* <RequiredWrap> * </RequiredWrap> */}
                Primary Sales Representative Split
              </div>
              <Input type="number" value={this.state.primary_sale_representative_split_percentage} onChange={e => this.changePrimarySalesRepresentativeSplit(e.target.value)} />
            </InputWrapper>
            <InputWrapper>
              <div>
                {/* <RequiredWrap> * </RequiredWrap> */}
             Secondary Sales Representative
              </div>
              <Select
                placeholder="Select"
                onChange={value => this.changeSecondarySalesRepresentative(value)}
                value={this.state.secondary_sale_representative}
                style={{
                  width: 200,
                }}
                options={SALES_REPRESENTATIVE}
              />
            </InputWrapper>
            <InputWrapper>
              <div>
                {/* <RequiredWrap> * </RequiredWrap> */}
                Secondary Sales Representative Split
              </div>
              <Input type="number" value={this.state.secondary_sale_representative_split_percentage} onChange={e => this.changeSecondarySalesRepresentativeSplit(e.target.value)} />
            </InputWrapper>
            <InputWrapper>
              <div>
                {/* <RequiredWrap> * </RequiredWrap> */}
              Previous Brokerage Name
              </div>
              <Input type="text" value={this.state.past_brokerage_name} onChange={e => this.changePastBrokerageName(e.target.value)} />
            </InputWrapper>
          </BlockDiv>
          <BlockDiv mt="30px">
            <InputWrapper>
              <div>
                Hide Radius logo for this team?
              </div>
              <Switch
                checked={this.state.hide_radius_logo}
                onChange={(value) => {
                  this.setState({ hide_radius_logo: value })
                }}
              />
            </InputWrapper>

            <InputWrapperNew>
              <div>
                Sidebar link hover color (hex only, example: #393c5d)
              </div>
              <ColorPickerWithInput
                color={this.state.brand_primary_color}
                onChange={(color) => {
                  this.setState({ brand_primary_color: color })
                }}
              />
            </InputWrapperNew>

            <InputWrapperNew>
              <div>
                Sidebar background color (hex only, example: #393c5d)
              </div>
              <ColorPickerWithInput
                color={this.state.brand_background_color}
                onChange={(color) => {
                  this.setState({ brand_background_color: color })
                }}
              />
            </InputWrapperNew>
          </BlockDiv>
          <BlockDiv mt="30px">
            <InputWrapperNew>
              <div>
                Mobile theme light color (hex only, example: #393c5d)
              </div>
              <ColorPickerWithInput
                color={this.state.mobile_theme_light_color}
                onChange={(color) => {
                  this.setState({ mobile_theme_light_color: color })
                }}
              />
            </InputWrapperNew>

            <InputWrapperNew>
              <div>
                Mobile theme dark color (hex only, example: #393c5d)
              </div>
              <ColorPickerWithInput
                color={this.state.mobile_theme_dark_color}
                onChange={(color) => {
                  this.setState({ mobile_theme_dark_color: color })
                }}
              />
            </InputWrapperNew>
          </BlockDiv>
          <InputWrapper mt="35px">
            <div>
              {/* <RequiredWrap> * </RequiredWrap> */}
            About Team
            </div>
            <RichTextEditorWrapper>
              <RichTextEditor saveRTF={value => this.changeTeamInfo("about_team", value)} text={this.state.about_team} height="150px" />
            </RichTextEditorWrapper>
          </InputWrapper>
          <InputWrapper mt="35px">
            <div>
              {/* <RequiredWrap> * </RequiredWrap> */}
            Team Benefits
            </div>
            <RichTextEditorWrapper>
              <RichTextEditor saveRTF={value => this.changeTeamInfo("other_benefits", value)} text={this.state.other_benefits} height="150px" />
            </RichTextEditorWrapper>
          </InputWrapper>
          <InputWrapper mt="35px">
            <div>
              {/* <RequiredWrap> * </RequiredWrap> */}
              Team Icon
            </div>
            <ImageUploaderContainer>
              <ImageUploader
                buttonText="Upload/Edit Team Icon"
                onChange={(picture) => { this.createReactImageCropReader(picture, "icon") }}
                imgExtension={[".jpg", ".gif", ".png", ".gif", ".jpeg"]}
                maxFileSize={5242880}
                singleImage
              />
              {/* https://staging-radius.imgix.net/BlankImage.svg */}
              {imageLoading ? <div>uploading....</div> : (
                <ImageWrapper>
                  {this.state.iconUrl ? (
                    <>
                      <img width="300" style={{ border: "2px solid #096dd9" }} src={this.state.iconUrl} />
                      <CloseCircleTwoToneIcon
                        onClick={() => { this.removeImage("icon") }}
                      />
                    </>
                  ) : (
                    <>
                      <img width="200" src="https://staging-radius.imgix.net/BlankImage.svg" />
                    </>
                  )}
                </ImageWrapper>
              )}
            </ImageUploaderContainer>
            {iconEditShow && (<PhotoEditor type={type} imageSrc={iconSrc} uploadImage={this.uploadTeamCoverImage} closeImageEdit={this.closeImageEdit} cropConfig={1} />)}
          </InputWrapper>
          <InputWrapper mt="35px">
            <ImageContainer>
              <div>
                Team Lead Image
              </div>
            </ImageContainer>
            <ImageUploaderContainer>
              <ImageUploader
                buttonText="Choose Admin/Team Lead Image"
                onChange={(picture) => { this.createReactImageCropReader(picture, "adminImage") }}
                imgExtension={[".jpg", ".gif", ".png", ".gif", ".jpeg"]}
                maxFileSize={5242880}
                singleImage
              />
              {imageLoading ? <div>uploading....</div> : (
                <ImageWrapper>
                  {this.state.adminImageUrl ? (
                    <>
                      <img width="300" style={{ border: "2px solid #096dd9" }} src={this.state.adminImageUrl} />
                      <CloseCircleTwoToneIcon
                        onClick={() => { this.removeImage("adminImage") }}
                      />
                    </>
                  ) : (<img width="200" src="https://staging-radius.imgix.net/BlankImage.svg" />)}
                </ImageWrapper>

              )}
            </ImageUploaderContainer>
            {adminImageEditShow && (<PhotoEditor type={type} imageSrc={adminImageSrc} uploadImage={this.uploadTeamCoverImage} closeImageEdit={this.closeImageEdit} cropConfig={1} />)}
          </InputWrapper>

          <InputWrapper mt="35px">
            <ImageContainer>
              <div>
                {/* <RequiredWrap> * </RequiredWrap> */}
                Team Cover Image
              </div>
            </ImageContainer>
            <ImageUploaderContainer>
              <ImageUploader
                buttonText="Upload Team Cover Image"
                onChange={(picture) => { this.createReactImageCropReader(picture, "teamCoverImage") }}
                imgExtension={[".jpg", ".gif", ".png", ".gif", ".jpeg"]}
                maxFileSize={5242880}
                singleImage
              />
              {imageLoading ? <div>uploading....</div> : (
                <ImageWrapper>
                  {this.state.teamCoverImageUrl ? (
                    <>
                      <img width="300" style={{ border: "2px solid #096dd9" }} src={this.state.teamCoverImageUrl} />

                      <CloseCircleTwoToneIcon
                        onClick={() => { this.removeImage("teamCoverImage") }}
                      />
                    </>
                  ) : (<img width="200" src="https://staging-radius.imgix.net/BlankImage.svg" />)}
                </ImageWrapper>
              )}
            </ImageUploaderContainer>
          </InputWrapper>
          {teamCoverImageEditShow && (<PhotoEditor type={type} imageSrc={teamCoverImageSrc} uploadImage={this.uploadTeamCoverImage} closeImageEdit={this.closeImageEdit} />)}

          <InputWrapper mt="35px">
            <ImageContainer>
              <div>
                Team Gallery Image 1
              </div>
            </ImageContainer>
            <ImageUploaderContainer>
              <ImageUploader
                buttonText="Upload Team Gallery Image 1"
                onChange={(picture) => { this.createReactImageCropReader(picture, "teamGalleryImage1") }}
                imgExtension={[".jpg", ".gif", ".png", ".gif", ".jpeg"]}
                maxFileSize={5242880}
                singleImage
              />
              {imageLoading ? <div>uploading....</div> : (
                <ImageWrapper>
                  {this.state.teamGalleryImage1Url ? (
                    <>
                      <img width="300" style={{ border: "2px solid #096dd9" }} src={this.state.teamGalleryImage1Url} />
                      <CloseCircleTwoToneIcon
                        onClick={() => { this.removeImage("teamGalleryImage1") }}
                      />
                    </>
                  ) : (<img width="200" src="https://staging-radius.imgix.net/BlankImage.svg" />)}
                </ImageWrapper>
              )}
            </ImageUploaderContainer>
          </InputWrapper>
          {teamGalleryImage1EditShow && (<PhotoEditor type={type} imageSrc={teamGalleryImage1Src} uploadImage={this.uploadTeamCoverImage} closeImageEdit={this.closeImageEdit} cropConfig={1} />)}

          <InputWrapper mt="35px">
            <ImageContainer>
              <div>
                Team Gallery Image 2
              </div>
            </ImageContainer>
            <ImageUploaderContainer>
              <ImageUploader
                buttonText="Upload Team Gallery Image 2"
                onChange={(picture) => { this.createReactImageCropReader(picture, "teamGalleryImage2") }}
                imgExtension={[".jpg", ".gif", ".png", ".gif", ".jpeg"]}
                maxFileSize={5242880}
                singleImage
              />
              {imageLoading ? <div>uploading....</div> : (
                <ImageWrapper>
                  {this.state.teamGalleryImage2Url ? (
                  <>
                    <img width="300" style={{ border: "2px solid #096dd9" }} src={this.state.teamGalleryImage2Url} />
                    <CloseCircleTwoToneIcon
                      onClick={() => { this.removeImage("teamGalleryImage2") }}
                    />
                  </>
                  ) : (<img width="200" src="https://staging-radius.imgix.net/BlankImage.svg" />)}
                </ImageWrapper>
              )}
            </ImageUploaderContainer>
          </InputWrapper>
          {teamGalleryImage2EditShow && (<PhotoEditor type={type} imageSrc={teamGalleryImage2Src} uploadImage={this.uploadTeamCoverImage} closeImageEdit={this.closeImageEdit} cropConfig={1} />)}

          <InputWrapper mt="35px">
            <ImageContainer>
              <div>
                Team Gallery Image 3
              </div>
            </ImageContainer>
            <ImageUploaderContainer>
              <ImageUploader
                buttonText="Upload Team Gallery Image 3"
                onChange={(picture) => { this.createReactImageCropReader(picture, "teamGalleryImage3") }}
                imgExtension={[".jpg", ".gif", ".png", ".gif", ".jpeg"]}
                maxFileSize={5242880}
                singleImage
              />
              {imageLoading ? <div>uploading....</div> : (
                <ImageWrapper>
                  {this.state.teamGalleryImage3Url ? (
                  <>
                    <img width="300" src={this.state.teamGalleryImage3Url} />
                    <CloseCircleTwoToneIcon
                      onClick={() => { this.removeImage("teamGalleryImage3") }}
                    />
                  </>
                  ) : (<img width="200" src="https://staging-radius.imgix.net/BlankImage.svg" />)}
                </ImageWrapper>
              )}
            </ImageUploaderContainer>
          </InputWrapper>
          {teamGalleryImage3EditShow && (<PhotoEditor type={type} imageSrc={teamGalleryImage3Src} uploadImage={this.uploadTeamCoverImage} closeImageEdit={this.closeImageEdit} cropConfig={1} />)}

          <InputWrapper mt="35px">
            <div>
              <input
                name="product_visible"
                type="checkbox"
                checked={this.state.visibleOnLandingPage}
                onChange={() => {
                  this.setState({
                    visibleOnLandingPage: !this.state.visibleOnLandingPage,
                  })
                }}
              />
              <Label htmlFor="product_visible">Visible on Product</Label>
            </div>
          </InputWrapper>
          {/* <ButtonWrap style={{ width: "50%", margin: "auto" }}>
            <Button onClick={() => this.saveTeam({})} success disabled={!this.state.name} type="primary" block size="large">
              Save Team
            </Button>
          </ButtonWrap> */}
        </div>
      )}
    </>
    )
  }

  handleAgentSearchChange = (e) => {
    this.setState({
      agentSearchText: e.target.value,
    }, () => this.search(this.state.agentSearchText))
  }

  handleReferringAgentChange = (e) => {
    this.setState({
      referringAgentSearchText: e.target.value,
    }, () => this.search(this.state.referringAgentSearchText, true))
  }

  addToTeam = (agent) => {
    const members = this.state.members
    members.push(agent)
    this.createTeam({ saveTeamMemberOnly: true })
    this.setState({ members, currentSelectedAgent: null })
  }

  search = async (value, isReferringAgentSearch) => {
    const searchBody = {
      ascending: false,
      facade: false,
      from: 0,
      size: 10,
      sortIsAsc: false,
      text_search_params: ["email", "firstname", "lastname", "full_name"],
      text_value: value,
      unRegistered: false,
    }

    let resp = await fetch(`${baseUrl}/v1.0/agent/elastic/query`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "internal-id": token,
        "X-User-Agent": "agent-php",
      },
      body: JSON.stringify(searchBody),
    })

    resp = await resp.json()
    if (this.state.members && this.state.members.length > 0) {
      const currentMemberIds = this.state.members.map(agent => agent.id)
      resp.response.agents = resp.response.agents.filter(agent => currentMemberIds.indexOf(agent.id) === -1)
    }
    if (!isReferringAgentSearch) {
      this.setState({ searchResults: resp.response.agents })
    } else {
      this.setState({ referringAgentSearchResults: resp.response.agents })
    }
  }

  changeTeamName = (value) => {
    this.setState({ name: value })
  }

  changeTeamCity = (value) => {
    this.setState({ city: value })
  }

  changeTeamState = (value) => {
    this.setState({ state: value })
  }

  changeTeamInfo = (key, value) => {
    this.setState({ [key]: value })
  }

  changeTeamProductionVolume = (value) => {
    this.setState({ productionVolume: value })
  }

  changePrimarySalesRepresentative = (value) => {
    this.setState({ primary_sale_representative: value })
  }

  changeSecondarySalesRepresentative = (value) => {
    this.setState({ secondary_sale_representative: value })
  }

  changePrimarySalesRepresentativeSplit = (value) => {
    this.setState({ primary_sale_representative_split_percentage: value })
  }

  changeSecondarySalesRepresentativeSplit = (value) => {
    this.setState({ secondary_sale_representative_split_percentage: value })
  }

  changePastBrokerageName = (value) => {
    this.setState({ past_brokerage_name: value })
  }

  handleOpenModal() {
    this.setState({ showModal: true })
  }

  handleOpenInviteTCModal(value) {
    this.setState({ showInviteTCModal: value })
  }

  handleOpenJobCreateModal(flag) {
    this.setState({ showJobCreateModal: flag })
  }

  handleViewJobModal(flag) {
    this.setState({ viewJobModal: flag })
  }

  handleCloseModal() {
    this.setState({
      currentSelectedAgent: null, searchResults: [], agentSearchText: null, showModal: false,
      isNewUserType: null, newUserRole: null, inviteType: 1,
    })
  }

  handleAgentSelect = (agent) => {
    agent.is_brokerage_admin = false
    agent.is_co_team_lead = false
    this.setState({
      currentSelectedAgent: agent,
      searchResults: [],
      agentSearchText: "",
    })
  }

  handleReferringAgentSelect = (agent) => {
    agent.is_brokerage_admin = false
    agent.is_co_team_lead = false
    this.setState({
      currentReferringAgentSelected: agent,
      referringAgentSearchResults: [],
      referringAgentSearchText: "",
    })
  }

  getTeams = async (teamId) => {
    try {
      this.setState({
        teamInfoLoading: true,
      })
      let teams = await fetch(`${baseUrl}/v1.0/brokerage-teams?id=${teamId}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "internal-id": token,
        },
      })
      teams = await teams.json()
      teams = teams.response
      const team = teams[0]
      let teamTCs = await fetch(`${baseUrl}/v1.0/brokerage-team-tc/${teamId}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "internal-id": token,
        },
      })
      teamTCs = await teamTCs.json()
      teamTCs = teamTCs.response
      // const teamAllTCs = teamTCs[0]

      const {
        members,
        name,
        id,
        icon_url: iconUrl,
        admin_image_url: adminImageUrl,
        visible_on_landing_page,
        city,
        state,
        production_volume,
        about_team,
        other_benefits,
        team_images,
        profile_name,
        is_cashback_supported,
        hide_radius_logo,
        brand_primary_color,
        brand_background_color,
        mobile_theme_light_color,
        mobile_theme_dark_color,
        past_brokerage_name,
        primary_sale_representative,
        secondary_sale_representative,
        primary_sale_representative_split_percentage,
        secondary_sale_representative_split_percentage,
        internal_cap_reset_date,
        team_cap: teamCap,
        radius_fee_paid_by: radiusFeePaidBy,
        radius_fee_type: radiusFeeType,
        radius_fee_amount: radiusFeeAmount,
        radius_fee_percentage: radiusFeePercentage,
        cda_type: cdaType,
        cda_settings: cdaSettings,
      } = team || {}
      
      // Initialize capResetDates from members data
      const capResetDates = {};
      if (members && members.length > 0) {
        members.forEach(member => {
          if (member.internal_cap_reset_date) {
            if (typeof member.internal_cap_reset_date === 'string') {
              const dateMoment = moment(member.internal_cap_reset_date, "YYYY-MM-DD HH:mm:ss");
              if (dateMoment.isValid()) {
                capResetDates[member.id] = dateMoment.valueOf();
              } else {
                capResetDates[member.id] = null; // Or handle error appropriately
              }
            } else if (typeof member.internal_cap_reset_date === 'number') {
              // Assuming it's already a timestamp (e.g., seconds from other sources)
              capResetDates[member.id] = member.internal_cap_reset_date * 1000;
            } else {
              capResetDates[member.id] = null;
            }
          }
        });
      }
      
      let teamCoverImageUrl = team_images ? team_images.find(im => im.type === "banner") : ""
      teamCoverImageUrl = teamCoverImageUrl ? teamCoverImageUrl.path : ""
      let teamGalleryImage1Url = team_images ? team_images.find(im => im.type === "other") : ""
      teamGalleryImage1Url = teamGalleryImage1Url ? teamGalleryImage1Url.path : ""
      let teamGalleryImage2Url = team_images ? team_images.find(im => im.type === "other" && im.path !== teamGalleryImage1Url) : ""
      teamGalleryImage2Url = teamGalleryImage2Url ? teamGalleryImage2Url.path : ""
      let teamGalleryImage3Url = team_images ? team_images.find(im => im.type === "other" && im.path !== teamGalleryImage1Url && im.path !== teamGalleryImage2Url) : ""
      teamGalleryImage3Url = teamGalleryImage3Url ? teamGalleryImage3Url.path : ""
      // Team-level fees are single calls. Per-agent radius & post-cap fees now
      // arrive inline on each members[] object from brokerage-teams?id=, so we
      // read them straight off members instead of one request per agent. Team
      // fees keep their per-agent fetch (unchanged HEAD behavior).
      const [teamRadiusFees, teamFees, agentTeamFeesByAgentId, teamPostCapFees] = await Promise.all([
        this.fetchTeamRadiusFees(teamId),
        this.fetchTeamFees(teamId),
        this.fetchAllAgentTeamFees(teamId, members || []),
        this.fetchTeamPostCapFees(teamId),
      ])
      const agentRadiusFeesByAgentId = this.buildAgentFeeMapFromMembers(members, "radius_fees")
      const agentPostCapFeesByAgentId = this.buildAgentFeeMapFromMembers(members, "post_cap_radius_fees")
      this.setState({
        city,
        state,
        name,
        members,
        id,
        iconUrl,
        adminImageUrl,
        visibleOnLandingPage: Boolean(visible_on_landing_page),
        productionVolume: production_volume,
        about_team: about_team || "",
        other_benefits: other_benefits || "",
        teamCoverImageUrl,
        teamGalleryImage1Url,
        teamGalleryImage2Url,
        teamGalleryImage3Url,
        is_cashback_supported,
        hide_radius_logo,
        brand_primary_color,
        brand_background_color,
        mobile_theme_light_color,
        mobile_theme_dark_color,
        primary_sale_representative,
        secondary_sale_representative,
        primary_sale_representative_split_percentage,
        secondary_sale_representative_split_percentage,
        past_brokerage_name,
        profile_name,
        teamTCs,
        internal_cap_reset_date: internal_cap_reset_date ? (typeof internal_cap_reset_date === 'string' ? moment(internal_cap_reset_date, "YYYY-MM-DD HH:mm:ss").valueOf() : internal_cap_reset_date * 1000) : null,
        capResetDates,
        teamCap: teamCap || '',
        radiusFeePaidBy: radiusFeePaidBy === "agent" ? "agent" : "company",
        radiusFeeType: radiusFeeType || "flat",
        radiusFeeAmount: this.formatDecimalValue(radiusFeeAmount),
        radiusFeePercentage: radiusFeePercentage === null || radiusFeePercentage === undefined ? "" : radiusFeePercentage,
        savedRadiusFeePaidBy: radiusFeePaidBy === "agent" ? "agent" : "company",
        savedRadiusFeeType: radiusFeeType || "flat",
        savedRadiusFeeAmount: this.formatDecimalValue(radiusFeeAmount),
        savedRadiusFeePercentage: radiusFeePercentage === null || radiusFeePercentage === undefined ? "" : radiusFeePercentage,
        cdaType: cdaType || "full_transparency",
        cdaSettings: cdaSettings || "cda",
        teamRadiusFees,
        teamFees,
        agentRadiusFeesByAgentId,
        agentTeamFeesByAgentId,
        teamPostCapFees,
        agentPostCapFeesByAgentId,
      })
      this.setState({
        teamInfoLoading: false,
      })
    } catch (e) {
      console.log(e)
      bugsnagClient.notify(e)
    }
  }

  componentDidMount() {
    const { pathname } = root.location || ""
    if (pathname.indexOf("create") !== -1) {
      this.setState({ view: "create" })
      this.createDefaultTeam()
    } else {
      const { teamId } = this.props.match.params
      this.setState({ view: "edit" })
      this.getTeams(teamId)
    }
  }

  setCurrentAgentAdminRules = (val) => {
    const currentSelectedAgent = this.state.currentSelectedAgent
    currentSelectedAgent.is_brokerage_admin = val
    this.setState({ currentSelectedAgent })
  }

  setCurrentCoAgentAdminRules = (val) => {
    const currentSelectedAgent = this.state.currentSelectedAgent
    currentSelectedAgent.is_co_team_lead = val
    this.setState({ currentSelectedAgent })
  }

  getCreateView() {
    const keysDiv = this.getNameDiv()
    const {
      agentSearchText,
      searchResults,
      showModal,
      currentSelectedAgent,
      inviteType,
      isNewUserType,
    } = this.state

    const nowTime = (new Date().getTime() / 1000)
    return (
      <div>
        {keysDiv}
        <div>
          <Modal
            visible={showModal}
            onOk={() => {
              if (this.state.currentSelectedAgent) {
                this.addToTeam(currentSelectedAgent); this.handleCloseModal()
              }
            }}
            onCancel={() => this.handleCloseModal()}
          >
            <div className="modal-for-team">
              <div>
                <h2>Add new associate</h2>
                <span>
                  <TeamMemberInput placeholder="Search agent" onChange={this.handleAgentSearchChange} value={this.state.agentSearchText} />
                </span>
                <React.Fragment>
                  {this.state.agentSearchText
                    && this.state.searchResults
                    && this.state.searchResults.length > 0
                    && this.state.searchResults.map(item => (
                      <React.Fragment>
                        <StyledDiv onClick={() => this.handleAgentSelect(item)}>
                          <h5>
                            {item.firstname || ""}
                            {" "}
                            {item.lastname || ""}
                          </h5>
                          <small>{item.email}</small>
                          <hr />
                        </StyledDiv>
                        <br />
                      </React.Fragment>
                    ))}
                </React.Fragment>
              </div>
              <div>
                {this.state.currentSelectedAgent
                  && (
                    <div style={dealForm}>
                      <h5>
                        Adding Agent:
                        {this.state.currentSelectedAgent.firstname || " "}
                        {" "}
                        {this.state.currentSelectedAgent.lastname || " "}
                      </h5>
                      <div
                        style={{ display: "flex", gap: "20px", alignItems: "center" }}
                      >
                        <div className="deal-text">
                          <span className="label-text">
                            Team Lead:
                          </span>
                          &nbsp;
                          <select value={this.state.currentSelectedAgent.is_brokerage_admin ? 1 : 0} onChange={e => this.setCurrentAgentAdminRules(parseInt(e.target.value, 10))}>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                          </select>
                        </div>
                        <div className="deal-text">
                          <span className="label-text">
                            Co Team Lead:
                          </span>
                          &nbsp;
                          <select value={this.state.currentSelectedAgent.is_co_team_lead ? 1 : 0} onChange={e => this.setCurrentCoAgentAdminRules(parseInt(e.target.value, 10))}>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  )
                }
              </div>
              <div style={{
                  marginTop: "10px",
                }}>
                <p>Agent type</p>
                <Select
                  onChange={(value) => {
                    this.setState({
                      newUserRole: value,
                    });
                  }}
                  placeholder="Select role (admin/operations/referral)"
                  style={{ width: "100%" }}
                  value={this.state.newUserRole}
                >
                  <Select.Option value="admin_agent">Admin</Select.Option>
                  <Select.Option value="operation_agent">Operations</Select.Option>
                  <Select.Option value="referral_agent">Referral agent</Select.Option>
                </Select>
              </div>
              <div>
                <p>Invite Status for this agent</p>
                <Radio.Group
                  onChange={(e) => {
                    this.setState({
                      inviteType: e.target.value,
                    })
                  }}
                  value={inviteType}
                >
                  <Space direction="vertical">
                    <Radio value={1}>Invited</Radio>
                    <Radio value={2}>Accepted</Radio>
                    <Radio value={3}>Declined</Radio>
                  </Space>
                </Radio.Group>
              </div>
              <div
                style={{
                  marginTop: "10px",
                }}
              >
                <p>Add referring agent</p>
                <span>
                  <TeamMemberInput placeholder="Search referring agent" onChange={this.handleReferringAgentChange} value={this.state.referringAgentSearchText} />
                </span>
                <React.Fragment>
                  {this.state.referringAgentSearchText
                    && this.state.referringAgentSearchResults
                    && this.state.referringAgentSearchResults.length > 0
                    && this.state.referringAgentSearchResults.map(item => (
                      <React.Fragment>
                        <StyledDiv onClick={() => this.handleReferringAgentSelect(item)}>
                          <h5>
                            {item.firstname || ""}
                            {" "}
                            {item.lastname || ""}
                          </h5>
                          <small>{item.email}</small>
                          <hr />
                        </StyledDiv>
                        <br />
                      </React.Fragment>
                    ))}
                </React.Fragment>
              </div>
              <div style={{ marginTop: "10px" }}>
                <p>Team split %</p>
                <span>
                  <TeamMemberInput 
                    placeholder="Enter team split" 
                    value={this.state.teamSplit || ''}
                    onChange={(e) => this.setState({ teamSplit: e.target.value })}
                  />
                </span>
              </div>

              <div style={{ marginTop: "10px" }}>
                <p>Internal cap</p>
                <span>
                  <TeamMemberInput 
                    placeholder="Enter internal cap" 
                    value={this.state.internalCap || ''}
                    onChange={(e) => this.setState({ internalCap: e.target.value })}
                  />
                </span>
              </div>

              <div style={{ marginTop: "10px" }}>
                <p>Radius cap</p>
                <span>
                  <TeamMemberInput 
                    placeholder="Enter Radius cap" 
                    value={this.state.radiusCap || ''}
                    onChange={(e) => this.setState({ radiusCap: e.target.value })}
                  />
                </span>
              </div> 

              <div style={{ marginTop: "10px" }}>
                <p>Internal cap reset date</p>
              {/* <TextInput
                 name="confirmed_closed_on"
                 min={moment(nowTime).format("YYYY-MM-DD")}
                 label="Confirmed/Tentative Closed Date (Escrow)"
                 placeholder="Confirmed Closed On"
                 type="date"
                 fullWidth
                 fullHeight
                 /*value={form.confirmed_closed_on !== null ? moment.unix(form.confirmed_closed_on).format("YYYY-MM-DD") : (form.closed_on ? moment.unix(form.closed_on).format("YYYY-MM-DD") : null)}
                 isError={errorFields.confirmed_closed_on}
                 onChange={(e) => {
                   this.setState({
                     form: {
                       ...form,
                       confirmed_closed_on: e.target.value ? moment(e.target.value).unix() : null,
                     },
                   })
                 }}
               />   */}
                <DatePicker
                  placeholder="Select internal cap reset date"
                  onChange={(date) => {
                    this.setState({
                      internalCapResetDate: date ? date.unix() : null,
                    })
                  }}
                  // value={this.state.capResetDates[record.id] ? moment(this.state.capResetDates[record.id]) : null}
                  /*onChange={(date) => {
                    this.handleCapResetDateChange(record.id, date);
                    if (date) {
                      this.updateCapResetDate(record.id, Math.floor(date.valueOf() / 1000));
                    } else {
                      this.updateCapResetDate(record.id, null);
                    }
                  }}*/
                  style={{ width: '100%', height: "35px" }}
                />
              </div> 
              <div>
                {this.state.currentReferringAgentSelected
                  && (
                    <div style={dealForm}>
                      <h5>
                        Referring Agent:
                        {this.state.currentReferringAgentSelected.firstname || " "}
                        {" "}
                        {this.state.currentReferringAgentSelected.lastname || " "}
                      </h5>
                    </div>
                  )
                }
              </div>
              <br />
              <br />
              <br />
              
            </div>
          </Modal>
        </div>
      </div>
    )
  }

  getInviteTCModalView() {
    // const keysDiv = this.getNameDiv()
    const {
      agentSearchText,
      searchResults,
      showInviteTCModal,
      currentSelectedAgent,
      tcFullName,
      tcEmail,
    } = this.state

    return (
      <div>
        {/* {keysDiv} */}
        <div>
          <Modal
            visible={showInviteTCModal}
            okText="Invite TC"
            onOk={async () => {
              if (tcFullName && tcEmail) {
                this.handleOpenInviteTCModal(false)
                await this.createTCInvitation()
              }
            }}
            onCancel={() => {
              this.settcDetails("tcEmail", null)
              this.settcDetails("tcFullName", null)
              this.handleOpenInviteTCModal(false)
            }}
          >
            <div className="modal-for-team">
              <div>
                <h2>Add new TC</h2>
                <span>
                  <Input placeholder="Full Name" allowClear onChange={e => this.settcDetails("tcFullName", e.target.value)} />
                </span>
                <span>
                  <Input style={{ marginTop: 10 }} type="email" placeholder="Email (Invitation will be sent to this email)" allowClear onChange={e => this.settcDetails("tcEmail", e.target.value)} />
                </span>
                <React.Fragment>
                </React.Fragment>
              </div>

            </div>
          </Modal>
        </div>
      </div>
    )
  }

  createTCInvitation = async () => {
    const {
      tcFullName, tcEmail, id: teamId, members,
    } = this.state
    const teamLeadId = members.find(mm => mm.is_brokerage_admin)?.id
    const body = {
      agent_id: teamLeadId,
      firstname: tcFullName,
      lastname: "",
      email: tcEmail,
      share_link: `https://radiusagent.com/signup?agent_id=null&invite_type=tc_login&team_id=${teamId}&email_id=${tcEmail}`,
      brokerage_team_id: teamId,
      member_type: "team_tc"
    }
    
    try {
      let resp = await fetch(`${baseUrl}/v1.0/brokerage-team-tc`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "internal-id": token,
          "X-User-Agent": "agent-php",
        },
        body: JSON.stringify(body),
      })
      resp = await resp.json()
      if (resp.response.success) {
        message.success("Invited successfully!")
      }
      if (resp?.error?.message) {
        message.error(resp?.error?.message)
      }
      this.getTeams(teamId)
      this.settcDetails("tcFullName", "")
      this.settcDetails("tcEmail", "")
    } catch (err) {
      alert(1)
      message.error("Something went wrong, Try again later!")
    }
  }

  getInviteType = (id) => {
    switch (id) {
      case 1:
        return "invited"
      case 2:
        return "joined"
      case 3:
        return "declined"
      default:
        return "invited"
    }
  }

  createTeam = async ({ saveTeamMemberOnly }) => {
    try {
      const { history } = this.props
      const {
        teamCoverImageUrl, teamGalleryImage1Url, teamGalleryImage2Url, teamGalleryImage3Url,
        currentReferringAgentSelected, inviteType, isNewUserType, newUserRole, 
      } = this.state
      let url = "/v1.0/brokerage-teams"
      let method = "POST"
      if (this.state.id) {
        url = `/v1.0/brokerage-teams/${this.state.id}`
        method = "PUT"
      }

      const getAboutTeams = () => {
        const arr_img = []
        if (teamCoverImageUrl) {
          arr_img.push({
            url: teamCoverImageUrl,
            type: "banner",
          })
        }
        if (teamGalleryImage1Url) {
          arr_img.push({
            url: teamGalleryImage1Url,
            type: "other",
          })
        }
        if (teamGalleryImage2Url) {
          arr_img.push({
            url: teamGalleryImage2Url,
            type: "other",
          })
        }
        if (teamGalleryImage3Url) {
          arr_img.push({
            url: teamGalleryImage3Url,
            type: "other",
          })
        }
        return arr_img
        //PhotoEditor
      }

      const body = {
        name: this.state.name,
        city: this.state.city,
        state: this.state.state,
        icon_url: this.state.iconUrl,
        admin_image_url: this.state.adminImageUrl,
        production_volume: Number(this.state.productionVolume),
        visible_on_landing_page: Number(this.state.visibleOnLandingPage),
        about_team: this.state.about_team,
        other_benefits: this.state.other_benefits,
        array_images: getAboutTeams(),
        is_cashback_supported: this.state.is_cashback_supported,
        hide_radius_logo: this.state.hide_radius_logo,
        brand_primary_color: this.state.brand_primary_color,
        brand_background_color: this.state.brand_background_color,
        mobile_theme_light_color: this.state.mobile_theme_light_color,
        mobile_theme_dark_color: this.state.mobile_theme_dark_color,
        past_brokerage_name: this.state.past_brokerage_name,
        primary_sale_representative: this.state.primary_sale_representative,
        secondary_sale_representative: this.state.secondary_sale_representative,
        primary_sale_representative_split_percentage: Number(this.state.primary_sale_representative_split_percentage),
        secondary_sale_representative_split_percentage: Number(this.state.secondary_sale_representative_split_percentage),
        internal_cap_reset_date: this.state.internal_cap_reset_date ? Math.floor(this.state.internal_cap_reset_date / 1000) : null,
      }
      // const coverImage = body.array_images.find(im => im.type === "banner")
      if (!body.name) {
        if (saveTeamMemberOnly) {
          message.error("First fill all required fields for team and save !")
          const { members } = this.state
          members.pop()
          this.setState({
            activeKey: "1",
            members: [...members],
          })
          return
        }
        message.error("Please Fill All The Required Fields For Team Info")
        return
      }
      if (saveTeamMemberOnly && body.name && !this.state.id) {
        message.error("Save Team Info Details First before adding Team Member!")
        const { members } = this.state
        members.pop()
        this.setState({
          activeKey: "1",
          members: [...members],
        })
        return
      }
      this.setState({
        teamInfoLoading: true,
        apiCallActive: true,
      })
      let resp = await fetch(baseUrl + url, {
        method,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "internal-id": token,
          "X-User-Agent": "agent-php",
        },
        body: JSON.stringify(body),
      })

      resp = await resp.json()

      let teamId = this.state.id
      if (!this.state.id) {
        teamId = resp.response.id
      }
      if (this.state.members) {
        const body = {
          members: this.state.members.map((member) => {
            const agent = {}
            agent.agent_id = member.id
            agent.is_admin = member.is_brokerage_admin
            agent.is_co_team_lead = member.is_co_team_lead
            agent.brokerage_team_id = teamId
            return agent
          }),
        }

        const {
          members,
        } = this.state || {}
        const lastAgentAdded = [...members].pop()

        const requestBody = {
          brokerage_team_id: teamId,
          agent_id: lastAgentAdded.id,
          is_admin: lastAgentAdded.is_brokerage_admin,
          is_co_team_lead: lastAgentAdded.is_co_team_lead,
          invite_status: this.getInviteType(inviteType),
          is_user_role: newUserRole != null ? true : false,
          user_role_name: newUserRole,
          sender_id: currentReferringAgentSelected ? currentReferringAgentSelected.id : null,
          team_split: this.state.teamSplit ? Number(this.state.teamSplit) : null,
          internal_cap: this.state.internalCap ? Number(this.state.internalCap) : null, 
          radius_cap: this.state.radiusCap ? Number(this.state.radiusCap) : null,
          internal_cap_reset_date: this.state.internalCapResetDate ? Math.floor(this.state.internalCapResetDate) : null,
          //internal_cap_reset_date: this.state.capResetDates[lastAgentAdded.id] ? Math.floor(this.state.capResetDates[lastAgentAdded.id] / 1000) : null,
        }

        const newApiResponse = await fetch(`${baseUrl}/v1.0/brokerage-team/add-member`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "internal-id": token,
            "X-User-Agent": "agent-php",
          },
          body: JSON.stringify(requestBody),
        })

        this.getTeams(teamId)

        console.log(requestBody)

        // const resp = await fetch(`${baseUrl}/v1.0/brokerage-team/${teamId}/member`, {
        //   method: "POST",
        //   headers: {
        //     Accept: "application/json",
        //     "Content-Type": "application/json",
        //     "internal-id": token,
        //     "X-User-Agent": "agent-php",
        //   },
        //   body: JSON.stringify(body),
        // })
      }
      this.setState({ apiCallActive: false, teamInfoLoading: false })
      // notify.show("Team added successfully!", "success", 5000)

      //window.location.assign(`/rar/teams`)
      if (!this.state.id) {
        if (saveTeamMemberOnly) {
          message.error("Save Team Info Details First before adding Team Member!")
          const { members } = this.state
          members.pop()
          this.setState({
            activeKey: "1",
            members: [...members],
          })
          return
        }
        history.push("/broker/teams/list")
      }
      if (saveTeamMemberOnly) {
        message.success("Team updated successfully!")
      } else {
        message.success("Team Info save successfully!")
      }
    } catch (e) {
      console.log("e", e)
      message.error("Something went wrong. Try again later")
      // notify.show("Something went wrong, please try again", "error", 5000)
      this.setState({ apiCallActive: false })
    }
  }

  saveTeam = async ({ saveTeamMemberOnly }) => {
    try {
      const { history } = this.props
      const search = get(root, "location.search", {})

      const parsedQuery = queryString.parse(search)
      const {
        agentId,
      } = parsedQuery || {}

      const {
        teamCoverImageUrl, teamGalleryImage1Url, teamGalleryImage2Url, teamGalleryImage3Url,
        currentReferringAgentSelected,
      } = this.state
      let url = "/v1.0/brokerage-teams"
      let method = "POST"
      if (this.state.id) {
        url = `/v1.0/brokerage-teams/${this.state.id}`
        method = "PUT"
      }

      const getAboutTeams = () => {
        const arr_img = []
        if (teamCoverImageUrl) {
          arr_img.push({
            url: teamCoverImageUrl,
            type: "banner",
          })
        }
        if (teamGalleryImage1Url) {
          arr_img.push({
            url: teamGalleryImage1Url,
            type: "other",
          })
        }
        if (teamGalleryImage2Url) {
          arr_img.push({
            url: teamGalleryImage2Url,
            type: "other",
          })
        }
        if (teamGalleryImage3Url) {
          arr_img.push({
            url: teamGalleryImage3Url,
            type: "other",
          })
        }
        return arr_img
        //PhotoEditor
      }

      const body = {
        name: this.state.name,
        city: this.state.city,
        state: this.state.state,
        icon_url: this.state.iconUrl,
        admin_image_url: this.state.adminImageUrl,
        production_volume: Number(this.state.productionVolume),
        visible_on_landing_page: Number(this.state.visibleOnLandingPage),
        about_team: this.state.about_team,
        other_benefits: this.state.other_benefits,
        array_images: getAboutTeams(),
        is_cashback_supported: this.state.is_cashback_supported,
        hide_radius_logo: this.state.hide_radius_logo,
        brand_primary_color: this.state.brand_primary_color,
        brand_background_color: this.state.brand_background_color,
        mobile_theme_light_color: this.state.mobile_theme_light_color,
        mobile_theme_dark_color: this.state.mobile_theme_dark_color,
        past_brokerage_name: this.state.past_brokerage_name,
        primary_sale_representative: this.state.primary_sale_representative,
        secondary_sale_representative: this.state.secondary_sale_representative,
        primary_sale_representative_split_percentage: Number(this.state.primary_sale_representative_split_percentage),
        secondary_sale_representative_split_percentage: Number(this.state.secondary_sale_representative_split_percentage),
        internal_cap_reset_date: this.state.internal_cap_reset_date ? Math.floor(this.state.internal_cap_reset_date / 1000) : null,
      }
      // const coverImage = body.array_images.find(im => im.type === "banner")
      if (!body.name) {
        if (saveTeamMemberOnly) {
          message.error("First fill all required fields for team and save !")
          const { members } = this.state
          members.pop()
          this.setState({
            activeKey: "1",
            members: [...members],
          })
          return
        }
        message.error("Please Fill All The Required Fields For Team Info")
        return
      }
      if (saveTeamMemberOnly && body.name && !this.state.id) {
        message.error("Save Team Info Details First before adding Team Member!")
        const { members } = this.state
        members.pop()
        this.setState({
          activeKey: "1",
          members: [...members],
        })
        return
      }
      this.setState({
        teamInfoLoading: true,
        apiCallActive: true,
      })
      let resp = await fetch(baseUrl + url, {
        method,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "internal-id": token,
          "X-User-Agent": "agent-php",
        },
        body: JSON.stringify(body),
      })

      resp = await resp.json()

      let teamId = this.state.id
      if (!this.state.id) {
        teamId = resp.response.id
      }
      if (this.state.members) {
        const body = {
          members: this.state.members.map((member) => {
            const agent = {}
            agent.agent_id = member.id
            agent.is_admin = member.is_brokerage_admin
            agent.brokerage_team_id = teamId
            agent.invite_status = member.invite_status
            agent.is_co_team_lead = member.is_co_team_lead
            return agent
          }),
        }

        const resp = await fetch(`${baseUrl}/v1.0/brokerage-team/${teamId}/member`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "internal-id": token,
            "X-User-Agent": "agent-php",
          },
          body: JSON.stringify(body),
        })
      }
      this.setState({ apiCallActive: false, teamInfoLoading: false })
      // notify.show("Team added successfully!", "success", 5000)

      //window.location.assign(`/rar/teams`)
      if (!this.state.id) {
        if (saveTeamMemberOnly) {
          message.error("Save Team Info Details First before adding Team Member!")
          const { members } = this.state
          members.pop()
          this.setState({
            activeKey: "1",
            members: [...members],
          })
          return
        }
        history.push("/broker/teams/list")
      }

      if (agentId) {
        history.push(`/broker/dashboard/${agentId}/subscription`)
      }

      if (saveTeamMemberOnly) {
        message.success("Team updated successfully!")
      } else {
        message.success("Team Info save successfully!")
      }
    } catch (e) {
      console.log("e", e)
      message.error("Something went wrong. Try again later")
      // notify.show("Something went wrong, please try again", "error", 5000)
      this.setState({ apiCallActive: false })
    }
  }

  handleRemoveTeamMember = async (teamId, members) => {
    try {
      const body = {
        members: members.map((item) => {
          const currentDetails = { ...item }
          currentDetails.agent_id = item.id
          currentDetails.is_admin = item.is_brokerage_admin
          currentDetails.brokerage_team_id = parseInt(teamId, 10)
          return currentDetails
        }),
      }

      await fetch(`${baseUrl}/v1.0/brokerage-team/${teamId}/member`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "internal-id": token,
          "X-User-Agent": "agent-php",
        },
        body: JSON.stringify(body),
      })
      // notify.show("Team added successfully!", "success", 5000)
    } catch (e) {
      console.log(e)
      message.error("Something went wrong. Try again later")
      // notify.show("Something went wrong, please try again", "error", 5000)
      this.setState({ apiCallActive: false })
    }
  }

  tabChange = (key) => {
    this.setState({
      activeKey: key,
    })
  }

  showConfirm = (record) => {
    const { deleteJobs } = this.props
    const { jobSearch, teamId } = this.state
  }

  removeMember = (id) => {
    const { teamId: currentTeamId } = this.props.match.params
    confirm({
      title: "Do you Want to remove this Agent!",
      icon: <ExclamationCircleOutlined />,
      content: "You can again add him back from Add New Team Member option.",

      onOk: () => {
        const members = this.state.members.filter(agent => agent.id !== id)
        this.setState({ members })
        // this.createTeam({ saveTeamMemberOnly: true })
        this.handleRemoveTeamMember(currentTeamId, members)
      },
    })
  }

  updateTeamInviteStatus = (id, value) => {
    const { teamId: currentTeamId } = this.props.match.params

    confirm({
      title: "Do you want to update the team invite status?",
      icon: <ExclamationCircleOutlined />,
      content: "You can change this again by choosing a different status again.",

      onOk: () => {
        const {
          members,
        } = this.state || {}
        const currentMembers = [...members]
        currentMembers.forEach((item) => {
          const curr = item
          if (item.id === id) {
            curr.invite_status = value
          }
        })
        this.setState({ members: [...currentMembers] })
        //this.createTeam({ saveTeamMemberOnly: false })
        this.handleTeamMemberInviteStatus(currentTeamId, members)
      },
    })
  }

  updateUserToNewRole = (id, value, currentRole) => {
    const { teamId: currentTeamId } = this.props.match.params

    confirm({
      title: "Do you want to update the user role?",
      content: `This will cancel the subscription for ${this.labelRole(currentRole)} and assign it as ${this.labelRole(value)}. Do you still want to proceed?`,
      icon: <ExclamationCircleOutlined />,
      // content: "You can change this again by choosing a different status again.",

      onOk: () => {
        // const {
        //   members,
        // } = this.state || {}
        // const currentMembers = [...members]
        // currentMembers.forEach((item) => {
        //   const curr = item
        //   if (item.id === id) {
        //     curr.invite_status = value
        //   }
        // })
        // this.setState({ members: [...currentMembers] })
        //this.createTeam({ saveTeamMemberOnly: false })
        this.handleUpdateUserRole(currentTeamId, id, value)
      },
    })
  }

  handleTeamMemberInviteStatus = async (teamId, members) => {
    try {
      const body = {
        members: members.map((item) => {
          const currentDetails = { ...item }
          currentDetails.agent_id = item.id
          currentDetails.is_admin = item.is_brokerage_admin
          currentDetails.brokerage_team_id = parseInt(teamId, 10)
          return currentDetails
        }),
      }

      await fetch(`${baseUrl}/v1.0/brokerage-team/${teamId}/member`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "internal-id": token,
          "X-User-Agent": "agent-php",
        },
        body: JSON.stringify(body),
      })
      notify.show("Invite Status Updated successfully!", "success", 5000)
    } catch (e) {
      console.log(e)
      message.error("Something went wrong. Try again later")
      // notify.show("Something went wrong, please try again", "error", 5000)
      this.setState({ apiCallActive: false })
    }
  }

  handleUpdateUserRole = async (teamId, agentId, role_value) => {
    try {
      const body = {
        brokerage_team_id: parseInt(teamId, 10),
        agent_id: agentId,
        user_role_name: role_value,
      }

      await fetch(`${baseUrl}/v1.0/brokerage-team/update-user-role`, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "internal-id": token,
          "X-User-Agent": "agent-php",
        },
        body: JSON.stringify(body),
      })
      notify.show("Role updated successfully!", "success", 5000)
      window.location.reload();
    } catch (e) {
      console.log(e)
      message.error("Something went wrong. Try again later")
      // notify.show("Something went wrong, please try again", "error", 5000)
      this.setState({ apiCallActive: false })
    }
  }

  getMembersDiv = () => {
    console.log("===this.state.members=====000009999999880---===", this.state.members)
    // if (this.state.members && this.state.members.length === 0) {
    //   return <span>Add new members to the team!</span>
    // }
    const membersDiv = (
      <React.Fragment>
        <Table
          rowKey={(record) => String(record.id)}
          scroll={{ x: 2550 }}
          tableLayout="fixed"
          expandable={{
            expandedRowKeys: Object.keys(this.state.expandedAgentFeeRows || {}).filter(key => this.state.expandedAgentFeeRows[key]),
            expandIcon: () => null,
            rowExpandable: (record) => {
              const teamFees = Array.isArray(this.state.agentTeamFeesByAgentId && this.state.agentTeamFeesByAgentId[record.id])
                ? this.state.agentTeamFeesByAgentId[record.id].length > 0
                : false
              return teamFees
            },
            expandedRowRender: (record) => {
              const teamFees = Array.isArray(this.state.agentTeamFeesByAgentId && this.state.agentTeamFeesByAgentId[record.id])
                ? this.state.agentTeamFeesByAgentId[record.id]
                : []
              const showTeamFees = Boolean(this.state.expandedAgentTeamFeeRows && this.state.expandedAgentTeamFeeRows[record.id])

              if (!showTeamFees) return null

              return (
                <div>
                  {showTeamFees && teamFees.length ? this.renderTeamFeeList({
                    fees: teamFees,
                    onEdit: (fee) => this.openTeamFeeModal({ scope: "agent", record, fee }),
                    onDelete: (fee) => this.deleteTeamFeeRecord({ scope: "agent", record, fee }),
                    onAdd: () => this.openTeamFeeModal({ scope: "agent", record }),
                  }) : null}
                </div>
              )
            },
          }}
          columns={[
            {
              title: "Agent Name",
              dataIndex: "firstname",
              key: "firstname",
              width: 200,
              render: (text, record, index) => (
                <span>
                  {`${record.firstname || " "} ${record.lastname || " "}`}
                </span>
              ),
            },
            {
              title: "Member Type",
              dataIndex: "is_brokerage_admin",
              key: "is_brokerage_admin",
              width: 150,
              render: (text, record, index) => (
                <span>
                  <Tag color={record?.is_brokerage_admin ? "green" : "geekblue"}>
                    {record.is_brokerage_admin  ? (record.is_co_team_lead ? "Co Team Lead" : "Team Lead") : (record.is_associate ? "Team Member" : record?.user_role?.replace(/_/g, ' '))}
                  </Tag>
                </span>
              ),
            },
            {
              title: "Team Fee",
              key: "team_fee",
              width: 190,
              render: (text, record) => {
                const fees = Array.isArray(this.state.agentTeamFeesByAgentId && this.state.agentTeamFeesByAgentId[record.id])
                  ? this.state.agentTeamFeesByAgentId[record.id]
                  : []
                const isExpanded = Boolean(this.state.expandedAgentTeamFeeRows && this.state.expandedAgentTeamFeeRows[record.id])

                return (
                  <InlineFieldGroup style={{ gap: 10, flexWrap: "wrap" }}>
                    {fees.length ? (
                      <RadiusFeeSummaryAction
                        type="link"
                        onClick={() => {
                          this.setState((prevState) => {
                            const nextTeamExpanded = !(prevState.expandedAgentTeamFeeRows && prevState.expandedAgentTeamFeeRows[record.id])

                            return {
                              expandedAgentTeamFeeRows: {
                                ...prevState.expandedAgentTeamFeeRows,
                                [record.id]: nextTeamExpanded,
                              },
                              expandedAgentFeeRows: {
                                ...prevState.expandedAgentFeeRows,
                                [record.id]: nextTeamExpanded,
                              },
                            }
                          })
                        }}
                      >
                        {`${fees.length} fee${fees.length > 1 ? "s" : ""}`}
                        {isExpanded ? <DownOutlined /> : <RightOutlined />}
                      </RadiusFeeSummaryAction>
                    ) : null}
                    <AgentRadiusFeeAction
                      type="link"
                      onClick={() => this.openTeamFeeModal({ scope: "agent", record })}
                    >
                      + Add
                    </AgentRadiusFeeAction>
                  </InlineFieldGroup>
                )
              },
            },
            {
              title: "Post-Cap",
              key: "post_cap_fee",
              width: 240,
              render: (text, record) => {
                if (!record || record.id === null || record.id === undefined) {
                  return <span style={{ color: "#d9d9d9" }}>-</span>
                }
                const fees = this.getPostCapFeesForScope("agent", record.id)
                const groups = this.getPostCapGroups(fees)
                const canAddMore = this.getAvailablePostCapFeeTypes(fees).length > 0

                return (
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 10 }}>
                    {groups.map((group) => (
                      <div key={group.kind}>
                        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                          <span style={{ fontWeight: 500 }}>{this.getPostCapFeeTypeLabel(group.kind)}</span>
                          <FeeListActions>
                            <Button type="link" size="small" style={{ padding: "0 4px" }} icon={<EditOutlined />} onClick={() => this.openPostCapFeeModal({ scope: "agent", agentRecord: record, group })} />
                            <Button type="link" size="small" danger style={{ padding: "0 4px" }} icon={<DeleteOutlined />} onClick={() => this.deletePostCapFee({ scope: "agent", agentRecord: record, group })} />
                          </FeeListActions>
                        </div>
                        <div style={{ fontSize: 12, color: "#6b778c" }}>
                          {this.getPostCapAmountLabel(group)} · {this.getPostCapFeePayerLabel(group.paid_by)}
                          {group.set_as_team_cap ? <Tag color="blue" style={{ marginLeft: 6 }}>Team cap</Tag> : null}
                        </div>
                      </div>
                    ))}
                    {canAddMore ? (
                      <AgentRadiusFeeAction
                        type="link"
                        style={{ alignSelf: "flex-start", paddingLeft: 0, paddingRight: 0 }}
                        onClick={() => this.openPostCapFeeModal({ scope: "agent", agentRecord: record })}
                      >
                        + Add Post-Cap
                      </AgentRadiusFeeAction>
                    ) : null}
                  </div>
                )
              },
            },
            {
              title: "Commission Breakdown Visibility",
              key: "can_confirm_cda_breakdown",
              width: 220,
              render: (text, record) => (
                this.canShowCdaConfirmationToggle(record) ? (
                  <Switch
                    checked={this.getCdaConfirmationValue(record)}
                    onChange={(checked) => this.handleCdaConfirmationToggle(record, checked)}
                  />
                ) : (
                  <span style={{ color: "#d9d9d9" }}>-</span>
                )
              ),
            },
            {
              title: "Actions",
              dataIndex: "actions",
              key: "actions",
              width: 100,
              render: (text, record, index) => (
                <Button type="link" danger onClick={() => this.removeMember(record.id)}>Remove</Button>
              ),
            },
            {
              title: "Invite Status",
              dataIndex: "invite_status",
              key: "invite_status",
              width: 260,
              render: (text, record, index) => (
                <>
                  {console.log("record", record.invite_status)}
                  <Select
                    onChange={value => this.updateTeamInviteStatus(record.id, value)}
                    style={{
                      width: 250,
                    }}
                    value={record.invite_status}
                  >
                    <Select.Option value="invited">Invited</Select.Option>
                    <Select.Option value="joined">Accepted</Select.Option>
                    <Select.Option value="declined">Declined</Select.Option>
                  </Select>
                </>
                
              ),
            },
            {
              title: "User permission",
              // dataIndex: "invite_status",
              // key: "invite_status",
              width: 260,
              render: (text, record, index) => (
                <>
                  <Select
                    onChange={value => this.updateUserToNewRole(record.id, value, record.is_brokerage_admin ? (record.is_co_team_lead ? "Co Team Lead" : "Team Lead") : (record.is_associate ? "Team Member" : record?.user_role?.replace(/_/g, ' ')))}
                    style={{
                      width: 250,
                    }}
                    value={record.user_role}
                  >
                    <Select.Option value="referral_agent">Referral agent</Select.Option>
                    <Select.Option value="admin_agent">Admin</Select.Option>
                    <Select.Option value="operation_agent">Operations</Select.Option>
                  </Select>
                </>
              ),
            },
            {
              title: "Radius Cap",
              width: 120,
              render: (text, record, index) => (
                <InputNumber
                  placeholder="Enter Radius Cap"
                  value={record?.cap}
                  min={0}
                  onChange={(value) => this.handleRadiusCapChange(record.id, value)}
                  onPressEnter={(e) => this.updateRadiusCap(record.id, e.target.value)}
                  onBlur={(e) => this.updateRadiusCap(record.id, e.target.value)}
                  style={{ width: '100%' }}
                />
              ),
            },
            {
              title: "Internal Cap",
              width: 120,
              render: (text, record, index) => (
                <InputNumber
                  placeholder="Enter Internal Cap"
                  value={record.internal_cap}
                  min={0}
                  onChange={(value) => this.handleInternalCapChange(record.id, value)}
                  onPressEnter={(e) => this.updateInternalCap(record.id, e.target.value)}
                  onBlur={(e) => this.updateInternalCap(record.id, e.target.value)}
                  style={{ width: '100%' }}
                />
              ),
            },
            {
              title: "Team Split",
              width: 120,
              render: (text, record) => (
                <InputNumber
                  placeholder="Enter Team Split"
                  value={record.team_split}
                  min={0}
                  onChange={(value) => this.handleTeamSplitChange(record.id, value)}
                  onPressEnter={(e) => this.updateTeamSplit(record.id, e.target.value)}
                  onBlur={(e) => this.updateTeamSplit(record.id, e.target.value)}
                  style={{ width: '100%' }}
                />
              ),
            },
            {
              title: "Pre Radius Progress to Internal Cap",
              width: 220,
              render: (text, record) => (
                <InputNumber
                  placeholder="Enter pre-Radius amount"
                  value={record.internal_cap_offset}
                  min={0}
                  onChange={(value) => this.handleInternalCapOffsetChange(record.id, value)}
                  onPressEnter={(e) => this.updateInternalCapOffset(record.id, e.target.value)}
                  onBlur={(e) => this.updateInternalCapOffset(record.id, e.target.value)}
                  style={{ width: '100%' }}
                />
              ),
            },
            {
              title: "Progress to Internal Cap",
              key: "progress_to_internal_cap_new",
              width: 170,
              render: (text, record) => {
                const v = record.progress_to_internal_cap_new
                const display = v !== null && v !== undefined && v !== "" ? v : "—"
                return <span>{display}</span>
              },
            },
            {
              title: "Display cap details",
              key: "show_progress_to_cap_to_agent",
              width: 200,
              render: (text, record) => (
                <Checkbox
                  checked={Number(record.show_progress_to_cap_to_agent) === 1}
                  onChange={(e) => this.handleShowProgressToCapToggle(record, e.target.checked)}
                />
              ),
            },
            {
              title: "Internal Cap Reset Date",
              width: 220,
              render: (text, record, index) => (
                <DatePicker
                  placeholder="Select reset date"
                  value={this.state.capResetDates[record.id] ? moment(this.state.capResetDates[record.id]) : null}
                  onChange={(date) => {
                    this.handleCapResetDateChange(record.id, date);
                    if (date) {
                      this.updateCapResetDate(record.id, Math.floor(date.valueOf() / 1000));
                    } else {
                      this.updateCapResetDate(record.id, null);
                    }
                  }}
                  style={{ width: "100%", minWidth: 200 }}
                />
              ),
            }
          ]}
          bordered={false}
          dataSource={this.state.members && this.state.members.length ? [...this.state.members] : []}
        />
      </React.Fragment>
    )

    return membersDiv
  }

  getTCsDiv = () => {
    console.log("===this.state.members=====000009999999880---===", this.state.teamTCs)
    // if (this.state.members && this.state.members.length === 0) {
    //   return <span>Add new members to the team!</span>
    // }
    const membersDiv = (
      <React.Fragment>
        <Table
          columns={[
            {
              title: "TC Name",
              dataIndex: "firstname",
              key: "firstname",
              width: "10%",
              render: (text, record, index) => (
                <span>
                  {`${record.firstname || " "} ${record.lastname || " "}`}
                </span>
              ),
            },
            {
              title: "Email",
              dataIndex: "email",
              key: "email",
              width: "10%",
              render: (text, record, index) => (
                <span>
                  {record.email}
                  {/* <Tag color={record.email ? "green" : "geekblue"}>
                    {record.email ? "Team Lead" : "Team Member"}
                  </Tag> */}
                </span>
              ),
            },
            {
              title: "Status",
              dataIndex: "status",
              key: "status",
              width: "10%",
              // render: (text, record, index) => (
              //   <Button type="link" danger onClick={() => this.removeMember(record.id)}>Remove</Button>
              // ),
              render: (text, record, index) => (
                <span>
                  {record.status}
                </span>
              ),
            },
          ]}
          bordered={false}
          dataSource={this.state.teamTCs && this.state.teamTCs.length ? [...this.state.teamTCs] : []}
        />
      </React.Fragment>
    )

    return membersDiv
  }

  getRowtitlesDiv = () => {
    const rowTitles = ["Name", "Role", "Action"]
    const rowTitlesdiv = rowTitles.map(val => (
      <div style={tableCellStyle}>
        {val}
      </div>
    ))
    return rowTitlesdiv
  }

  // Add these methods to your BrokerageTeam class

  // Store the temporary values for caps
  handleRadiusCapChange = (agentId, value) => {
    // Store the temporary value before API call
    const members = [...this.state.members];
    const memberIndex = members.findIndex(member => member.id === agentId);
    
    if (memberIndex !== -1) {
      members[memberIndex].cap = value;
      this.setState({ members });
    }
  }

  handleInternalCapChange = (agentId, value) => {
    // Store the temporary value before API call
    const members = [...this.state.members];
    const memberIndex = members.findIndex(member => member.id === agentId);
    
    if (memberIndex !== -1) {
      members[memberIndex].internal_cap = value;
      this.setState({ members });
    }
  }

  handleInternalCapOffsetChange = (agentId, value) => {
    const members = [...this.state.members];
    const memberIndex = members.findIndex(member => member.id === agentId);
    if (memberIndex !== -1) {
      members[memberIndex].internal_cap_offset = value;
      this.setState({ members });
    }
  }

  handleTeamSplitChange = (agentId, value) => {
    const members = [...this.state.members];
    const memberIndex = members.findIndex(member => member.id === agentId);
    if (memberIndex !== -1) {
      members[memberIndex].team_split = value;
      this.setState({ members });
    }
  }

  handleShowProgressToCapToggle = async (record, checked) => {
    const agentId = record.id
    const newVal = checked ? 1 : 0
    const prevVal = Number(record.show_progress_to_cap_to_agent) === 1 ? 1 : 0

    const members = [...this.state.members]
    const memberIndex = members.findIndex(member => member.id === agentId)
    if (memberIndex === -1) return

    members[memberIndex].show_progress_to_cap_to_agent = newVal
    this.setState({ members })

    try {
      const { id: teamId } = this.state
      if (!teamId) {
        members[memberIndex].show_progress_to_cap_to_agent = prevVal
        this.setState({ members })
        message.info("Please save the team first before editing this field")
        return
      }

      this.setState({ isUpdatingCap: true })

      const body = {
        brokerage_team_id: teamId,
        agent_id: agentId,
        show_progress_to_cap_to_agent: newVal,
      }

      const response = await fetch(`${baseUrl}/v1.0/brokerage-team/update-internal-cap`, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "internal-id": token,
          "X-User-Agent": "agent-php",
        },
        body: JSON.stringify(body),
      })

      const data = await response.json()

      if (data.response && data.response.success) {
        message.success("Display cap details updated successfully!")
      } else {
        members[memberIndex].show_progress_to_cap_to_agent = prevVal
        this.setState({ members })
        message.error(data.error?.message || "Failed to update setting")
      }

      this.setState({ isUpdatingCap: false })
    } catch (error) {
      console.error("Error updating show_progress_to_cap_to_agent:", error)
      const membersRevert = [...this.state.members]
      const ix = membersRevert.findIndex(m => m.id === agentId)
      if (ix !== -1) {
        membersRevert[ix].show_progress_to_cap_to_agent = prevVal
      }
      this.setState({ members: membersRevert, isUpdatingCap: false })
      message.error("Something went wrong. Please try again.")
    }
  }

  handleCdaConfirmationToggle = async (record, checked) => {
    const agentId = record.id
    const prevVal = this.getCdaConfirmationValue(record)

    const members = [...this.state.members]
    const memberIndex = members.findIndex(member => member.id === agentId)
    if (memberIndex === -1) return

    members[memberIndex].can_confirm_cda_breakdown = checked
    this.setState({ members })

    try {
      const { id: teamId } = this.state
      if (!teamId) {
        members[memberIndex].can_confirm_cda_breakdown = prevVal
        this.setState({ members })
        message.info("Please save the team first before editing this field")
        return
      }

      const body = {
        team_id: teamId,
        agent_id: agentId,
        can_confirm: checked,
      }

      const response = await fetch(`${baseUrl}/v1.0/brokerage-cda/team-members/cda-confirm-permission`, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "internal-id": token,
          "X-User-Agent": "agent-php",
        },
        body: JSON.stringify(body),
      })

      const data = await response.json()

      if (
        response.ok
        && (
          data.response === "OK"
          || data.response?.success
          || typeof data.response === "object"
        )
      ) {
        message.success("Commission breakdown visibility updated successfully!")
      } else {
        members[memberIndex].can_confirm_cda_breakdown = prevVal
        this.setState({ members })
        message.error(data.error?.message || "Failed to update commission breakdown visibility")
      }
    } catch (error) {
      console.error("Error updating commission breakdown visibility:", error)
      const membersRevert = [...this.state.members]
      const ix = membersRevert.findIndex(member => member.id === agentId)
      if (ix !== -1) {
        membersRevert[ix].can_confirm_cda_breakdown = prevVal
      }
      this.setState({ members: membersRevert })
      message.error("Something went wrong. Please try again.")
    }
  }

  // API calls to update caps
  updateRadiusCap = async (agentId, value) => {
    try {
      if (!value) return; // Don't make API call if value is empty
      
      const numericValue = Number(value);
      if (isNaN(numericValue)) return; // Don't make API call if value is not a number
      
      const body = {
        agent_id: agentId,
        radius_cap: numericValue
      };
      
      this.setState({ isUpdatingCap: true });
      
      const response = await fetch(`${baseUrl}/v1.0/brokerage-team/update-radius-cap`, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "internal-id": token,
          "X-User-Agent": "agent-php",
        },
        body: JSON.stringify(body),
      });
      
      const data = await response.json();
      
      if (data.response && data.response.success) {
        message.success("Radius Cap updated successfully!");
      } else {
        message.error(data.error?.message || "Failed to update Radius Cap");
      }
      
      this.setState({ isUpdatingCap: false });
    } catch (error) {
      console.error("Error updating radius cap:", error);
      message.error("Something went wrong. Please try again.");
      this.setState({ isUpdatingCap: false });
    }
  }

  updateInternalCap = async (agentId, value) => {
    try {
      if (!value) return; // Don't make API call if value is empty
      
      const numericValue = Number(value);
      if (isNaN(numericValue)) return; // Don't make API call if value is not a number
      
      const { id: teamId } = this.state;
      
      const body = {
        brokerage_team_id: teamId,
        agent_id: agentId,
        internal_cap: numericValue
      };
      
      this.setState({ isUpdatingCap: true });
      
      const response = await fetch(`${baseUrl}/v1.0/brokerage-team/update-internal-cap`, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "internal-id": token,
          "X-User-Agent": "agent-php",
        },
        body: JSON.stringify(body),
      });
      
      const data = await response.json();
      
      if (data.response && data.response.success) {
        message.success("Internal Cap updated successfully!");
      } else {
        message.error(data.error?.message || "Failed to update Internal Cap");
      }
      
      this.setState({ isUpdatingCap: false });
    } catch (error) {
      console.error("Error updating internal cap:", error);
      message.error("Something went wrong. Please try again.");
      this.setState({ isUpdatingCap: false });
    }
  }

  updateInternalCapOffset = async (agentId, value) => {
    try {
      const { id: teamId } = this.state;
      if (!teamId) {
        message.info("Please save the team first before editing this field");
        return;
      }
      const numericValue =
        value === "" || value === null || value === undefined ? 0 : Number(value);
      if (value !== "" && value !== null && value !== undefined && Number.isNaN(numericValue)) {
        return;
      }

      this.setState({ isUpdatingCap: true });

      const body = {
        brokerage_team_id: teamId,
        agent_id: agentId,
        internal_cap_offset: numericValue,
      };

      const response = await fetch(`${baseUrl}/v1.0/brokerage-team/update-internal-cap`, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "internal-id": token,
          "X-User-Agent": "agent-php",
        },
        body: JSON.stringify(body),
      });

      const data = await response.json();

      if (data.response && data.response.success) {
        message.success("Pre Radius Progress to Internal Cap updated successfully!");
      } else {
        message.error(
          data.error?.message || "Failed to update Pre Radius Progress to Internal Cap"
        );
      }

      this.setState({ isUpdatingCap: false });
    } catch (error) {
      console.error("Error updating internal cap offset:", error);
      message.error("Something went wrong. Please try again.");
      this.setState({ isUpdatingCap: false });
    }
  }

  updateTeamSplit = async (agentId, value) => {
    try {
      const { id: teamId } = this.state;
      if (!teamId) {
        message.info("Please save the team first before editing this field");
        return;
      }
      if (value === "" || value === null || value === undefined) return;

      const numericValue = Number(value);
      if (Number.isNaN(numericValue)) return;

      this.setState({ isUpdatingCap: true });

      const body = {
        brokerage_team_id: teamId,
        agent_id: agentId,
        team_split: numericValue,
      };

      const response = await fetch(`${baseUrl}/v1.0/brokerage-team/update-internal-cap`, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "internal-id": token,
          "X-User-Agent": "agent-php",
        },
        body: JSON.stringify(body),
      });

      const data = await response.json();

      if (data.response && data.response.success) {
        message.success("Team Split updated successfully!");
      } else {
        message.error(data.error?.message || "Failed to update Team Split");
      }

      this.setState({ isUpdatingCap: false });
    } catch (error) {
      console.error("Error updating team split:", error);
      message.error("Something went wrong. Please try again.");
      this.setState({ isUpdatingCap: false });
    }
  }

  // Add these methods to handle date changes for individual agents
  handleCapResetDateChange = (agentId, date) => {
    // Create a copy of the existing cap reset dates
    const capResetDates = {...this.state.capResetDates};
    
    // Store the date as a timestamp or null if date is cleared
    capResetDates[agentId] = date ? date.valueOf() : null;
    
    this.setState({ capResetDates });
  }

  updateCapResetDate = async (agentId, timestamp) => {
    try {
      // if (!timestamp) return; // Don't make API call if value is empty. Allow null to clear the date.
      
      const { id: teamId } = this.state;
      
      const body = {
        brokerage_team_id: teamId,
        agent_id: agentId,
        internal_cap_reset_date: timestamp
      };
      
      this.setState({ isUpdatingCapResetDate: true });
      
      const response = await fetch(`${baseUrl}/v1.0/brokerage-team/update-internal-cap-reset-date `, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "internal-id": token,
          "X-User-Agent": "agent-php",
        },
        body: JSON.stringify(body),
      });
      
      const data = await response.json();
      
      if (data.response && data.response.success) {
        message.success("Cap reset date updated successfully!");
      } else {
        message.error(data.error?.message || "Failed to update cap reset date");
      }
      
      this.setState({ isUpdatingCapResetDate: false });
    } catch (error) {
      console.error("Error updating cap reset date:", error);
      message.error("Something went wrong. Please try again.");
      this.setState({ isUpdatingCapResetDate: false });
    }
  }

  // Method to save team cap to database
  saveTeamCap = async (value) => {
    try {
      if (!value) return; // Don't make API call if value is empty
      
      const numericValue = Number(value);
      if (isNaN(numericValue)) return; // Don't make API call if value is not a number
      
      const { id: teamId } = this.state;
      if (!teamId) {
        message.info("Please save the team first before setting a team cap");
        return;
      }
      
      const body = {
        team_id: teamId,
        team_cap: numericValue
      };
      
      this.setState({ isSavingTeamCap: true });
      
      const response = await fetch(`${baseUrl}/v1.0/brokerage-team/add-team-cap`, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "internal-id": token,
          "X-User-Agent": "agent-php",
        },
        body: JSON.stringify(body),
      });
      
      const data = await response.json();
      
      if (data.response && data.response.success) {
        message.success("Team cap updated successfully!");
      } else {
        message.error(data.error?.message || "Failed to update team cap");
      }
      
      this.setState({ isSavingTeamCap: false });
    } catch (error) {
      console.error("Error updating team cap:", error);
      message.error("Something went wrong. Please try again.");
      this.setState({ isSavingTeamCap: false });
    }
  }

  // Handler for team cap input change
  handleTeamCapChange = (e) => {
    const value = e.target.value;
    this.setState({ teamCap: value });
    
    // Debounce the API call to avoid making too many requests
    if (this.teamCapTimeout) {
      clearTimeout(this.teamCapTimeout);
    }
    
    this.teamCapTimeout = setTimeout(() => {
      this.saveTeamCap(value);
    }, 500);
  }

  saveRadiusFeeSettings = async () => {
    try {
      const { id: teamId } = this.state
      if (!teamId) {
        message.info("Please save the team first before updating radius fee settings")
        return
      }

      const nextState = {
        radiusFeePaidBy: this.state.radiusFeePaidBy,
        radiusFeeType: this.state.radiusFeeType,
        radiusFeeAmount: this.state.radiusFeeAmount,
        radiusFeePercentage: this.state.radiusFeePercentage,
      }

      const body = {
        team_id: teamId,
        radius_fee_paid_by: nextState.radiusFeePaidBy === "company" ? "company" : "agent",
        radius_fee_type: nextState.radiusFeeType,
      }

      if (nextState.radiusFeeType === "flat" || nextState.radiusFeeType === "both") {
        const numericAmount = nextState.radiusFeeAmount === "" ? 0 : Number(nextState.radiusFeeAmount)
        if (Number.isNaN(numericAmount)) {
          message.error("Please enter a valid flat fee amount")
          return
        }
        body.radius_fee_amount = numericAmount
      }

      if (nextState.radiusFeeType === "percentage" || nextState.radiusFeeType === "both") {
        const numericPercentage = nextState.radiusFeePercentage === "" ? 0 : Number(nextState.radiusFeePercentage)
        if (Number.isNaN(numericPercentage)) {
          message.error("Please enter a valid percentage value")
          return
        }
        body.radius_fee_percentage = numericPercentage
        if (nextState.radiusFeeType === "percentage") {
          body.radius_fee_amount = numericPercentage
        }
      }

      this.setState({ isSavingRadiusFeeSettings: true })

      const response = await fetch(`${baseUrl}/v1.0/brokerage-team/radius-fee-settings`, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "internal-id": token,
          "X-User-Agent": "agent-php",
        },
        body: JSON.stringify(body),
      })

      const data = await response.json()

      if (data.response && data.response.success) {
        message.success("Radius fee settings updated successfully!")
        this.setState({
          savedRadiusFeePaidBy: nextState.radiusFeePaidBy,
          savedRadiusFeeType: nextState.radiusFeeType,
          savedRadiusFeeAmount: this.formatDecimalValue(nextState.radiusFeeAmount),
          savedRadiusFeePercentage: nextState.radiusFeePercentage,
          radiusFeeAmount: this.formatDecimalValue(nextState.radiusFeeAmount),
        })
        this.getTeams(teamId)
      } else {
        message.error(data.error?.message || "Failed to update radius fee settings")
      }

      this.setState({ isSavingRadiusFeeSettings: false })
    } catch (error) {
      console.error("Error updating radius fee settings:", error)
      message.error("Something went wrong. Please try again.")
      this.setState({ isSavingRadiusFeeSettings: false })
    }
  }

  handleRadiusFeePaidByChange = (value) => {
    this.setState({ radiusFeePaidBy: value })
  }

  handleRadiusFeeTypeChange = (value) => {
    this.setState({ radiusFeeType: value })
  }

  handleRadiusFeeAmountChange = (value) => {
    this.setState({ radiusFeeAmount: value })
  }

  handleRadiusFeePercentageChange = (value) => {
    this.setState({ radiusFeePercentage: value })
  }

  updateTransactionSettings = async (updates = {}) => {
    try {
      const { id: teamId, cdaType, cdaSettings } = this.state
      if (!teamId) {
        message.info("Please save the team first before updating transaction settings")
        return
      }

      const nextCdaType = Object.prototype.hasOwnProperty.call(updates, "cdaType")
        ? updates.cdaType
        : cdaType
      const nextCdaSettings = Object.prototype.hasOwnProperty.call(updates, "cdaSettings")
        ? updates.cdaSettings
        : cdaSettings

      this.setState({
        isSavingCdaType: true,
        cdaType: nextCdaType,
        cdaSettings: nextCdaSettings,
      })

      const response = await fetch(`${baseUrl}/v1.0/brokerage-team/cda-type`, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "internal-id": token,
          "X-User-Agent": "agent-php",
        },
        body: JSON.stringify({
          team_id: teamId,
          cda_type: nextCdaType,
          cda_settings: nextCdaSettings,
        }),
      })

      const data = await response.json()

      if (data && data.response && (data.response.cda_type || data.response.cda_settings)) {
        this.setState({
          cdaType: (data.response && data.response.cda_type) || nextCdaType,
          cdaSettings: (data.response && data.response.cda_settings) || nextCdaSettings,
        })
        message.success("Transaction settings updated successfully!")
      } else {
        message.error((data && data.error && data.error.message) || "Failed to update transaction settings")
        this.getTeams(teamId)
      }

      this.setState({ isSavingCdaType: false })
    } catch (error) {
      console.error("Error updating transaction settings:", error)
      message.error("Something went wrong. Please try again.")
      this.setState({ isSavingCdaType: false })
    }
  }

  handleCdaTypeChange = async (value) => {
    return this.updateTransactionSettings({ cdaType: value })
  }

  handleCdaSettingsChange = async (value) => {
    return this.updateTransactionSettings({ cdaSettings: value })
  }

  saveRadiusFeeModal = async () => {
    try {
      const {
        id: teamId,
        selectedAgentRadiusFee,
        radiusFeeModalScope,
        radiusFeeModalRepresentations,
        agentRadiusFeePaidBy,
        agentRadiusFeeType,
        agentRadiusFeeAmount,
        agentRadiusFeePercentage,
      } = this.state

      if (!teamId) {
        message.info("Please save the team first before updating the radius fee")
        return
      }

      if (!radiusFeeModalRepresentations || radiusFeeModalRepresentations.length === 0) {
        message.error("Please select at least one representation type")
        return
      }

      if (radiusFeeModalScope === "agent" && !(selectedAgentRadiusFee && selectedAgentRadiusFee.id)) {
        message.info("Please select an agent before updating the radius fee")
        return
      }

      const numericAmount = agentRadiusFeeAmount === "" ? null : Number(agentRadiusFeeAmount)
      const numericPercentage = agentRadiusFeePercentage === "" ? null : Number(agentRadiusFeePercentage)

      if ((agentRadiusFeeType === "flat" || agentRadiusFeeType === "both")
        && (numericAmount === null || Number.isNaN(numericAmount))) {
        message.error("Please enter a valid flat amount")
        return
      }

      if ((agentRadiusFeeType === "percentage" || agentRadiusFeeType === "both")
        && (numericPercentage === null || Number.isNaN(numericPercentage))) {
        message.error("Please enter a valid percentage")
        return
      }

      this.setState({ isSavingAgentRadiusFee: true })

      const query = radiusFeeModalScope === "team"
        ? `team_id=${teamId}`
        : `team_id=${teamId}&agent_id=${selectedAgentRadiusFee.id}`

      const endpoint = radiusFeeModalScope === "team"
        ? `${baseUrl}/v1.0/brokerage-team/radius-fees?${query}`
        : `${baseUrl}/v1.0/brokerage-team/agent-radius-fees?${query}`

      const body = {
        representation_types: radiusFeeModalRepresentations,
        paid_by: agentRadiusFeePaidBy,
        fee_type: agentRadiusFeeType,
      }

      if (agentRadiusFeeType === "flat" || agentRadiusFeeType === "both") {
        body.amount = numericAmount
      }

      if (agentRadiusFeeType === "percentage" || agentRadiusFeeType === "both") {
        body.percentage = numericPercentage
      }

      const response = await fetch(endpoint, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "internal-id": token,
          "X-User-Agent": "agent-php",
        },
        body: JSON.stringify(body),
      })

      const data = await response.json()

      if (response.ok && data && data.response && data.response.success) {
        message.success(`${radiusFeeModalScope === "team" ? "Team" : "Agent"} radius fee updated successfully!`)
        if (radiusFeeModalScope === "team") {
          const teamRadiusFees = (data.response && data.response.radius_fees) || await this.fetchTeamRadiusFees(teamId)
          this.setState({
            teamRadiusFees,
            expandedTeamRadiusFees: true,
          })
        } else {
          const agentFees = (data.response && data.response.radius_fees) || await this.fetchAgentRadiusFees(teamId, selectedAgentRadiusFee.id)
          this.setState((prevState) => ({
            agentRadiusFeesByAgentId: {
              ...prevState.agentRadiusFeesByAgentId,
              [selectedAgentRadiusFee.id]: agentFees,
            },
            expandedAgentRadiusFeeRows: {
              ...prevState.expandedAgentRadiusFeeRows,
              [selectedAgentRadiusFee.id]: true,
            },
            expandedAgentFeeRows: {
              ...prevState.expandedAgentFeeRows,
              [selectedAgentRadiusFee.id]: true,
            },
          }))
        }
        this.closeAgentRadiusFeeModal()
      } else {
        message.error((data && data.error && data.error.message) || `Failed to update ${radiusFeeModalScope} radius fee`)
        this.setState({ isSavingAgentRadiusFee: false })
      }
    } catch (error) {
      console.error("Error updating radius fee:", error)
      message.error("Something went wrong. Please try again.")
      this.setState({ isSavingAgentRadiusFee: false })
    }
  }

  deleteTeamRadiusFeeGroup = (group) => {
    confirm({
      title: "Delete this team radius fee?",
      icon: <ExclamationCircleOutlined />,
      onOk: async () => {
        try {
          const { id: teamId } = this.state
          const representationTypes = group && group.representation_type
            ? group.representation_type
            : (((group && group.representation_types) || []).join(","))
          const response = await fetch(
            `${baseUrl}/v1.0/brokerage-team/radius-fees?team_id=${teamId}&representation_types=${representationTypes}`,
            {
              method: "DELETE",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "internal-id": token,
                "X-User-Agent": "agent-php",
              },
            }
          )
          const data = await response.json()
          if (!response.ok || !(data && data.response && data.response.success)) {
            message.error((data && data.error && data.error.message) || "Failed to delete team radius fee")
            return
          }
          const teamRadiusFees = (data.response && data.response.radius_fees) || []
          this.setState({
            teamRadiusFees,
            expandedTeamRadiusFees: teamRadiusFees.length > 0 ? this.state.expandedTeamRadiusFees : false,
          })
          message.success("Team radius fee deleted successfully!")
        } catch (error) {
          console.error("Error deleting team radius fee:", error)
          message.error("Something went wrong. Please try again.")
        }
      },
    })
  }

  deleteAgentRadiusFeeGroup = (record, group) => {
    confirm({
      title: "Delete this agent radius fee?",
      icon: <ExclamationCircleOutlined />,
      onOk: async () => {
        try {
          const { id: teamId } = this.state
          const representationTypes = group && group.representation_type
            ? group.representation_type
            : (((group && group.representation_types) || []).join(","))
          const response = await fetch(
            `${baseUrl}/v1.0/brokerage-team/agent-radius-fees?team_id=${teamId}&agent_id=${record.id}&representation_types=${representationTypes}`,
            {
              method: "DELETE",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "internal-id": token,
                "X-User-Agent": "agent-php",
              },
            }
          )
          const data = await response.json()
          if (!response.ok || !(data && data.response && data.response.success)) {
            message.error((data && data.error && data.error.message) || "Failed to delete agent radius fee")
            return
          }
          const agentFees = (data.response && data.response.radius_fees) || []
          this.setState((prevState) => ({
            agentRadiusFeesByAgentId: {
              ...prevState.agentRadiusFeesByAgentId,
              [record.id]: agentFees,
            },
            expandedAgentRadiusFeeRows: {
              ...prevState.expandedAgentRadiusFeeRows,
              [record.id]: agentFees.length > 0
                ? (prevState.expandedAgentRadiusFeeRows && prevState.expandedAgentRadiusFeeRows[record.id])
                : false,
            },
            expandedAgentFeeRows: {
              ...prevState.expandedAgentFeeRows,
              [record.id]: (
                (agentFees.length > 0
                  ? (prevState.expandedAgentRadiusFeeRows && prevState.expandedAgentRadiusFeeRows[record.id])
                  : false)
                || Boolean(prevState.expandedAgentTeamFeeRows && prevState.expandedAgentTeamFeeRows[record.id])
              ),
            },
          }))
          message.success("Agent radius fee deleted successfully!")
        } catch (error) {
          console.error("Error deleting agent radius fee:", error)
          message.error("Something went wrong. Please try again.")
        }
      },
    })
  }

  renderRadiusFeeList = ({ groups = [], onEdit, onDelete, onAdd }) => {
    return (
      <FeeListContainer>
        <FeeListCard>
          <FeeListHeader>
            <div>Representation</div>
            <div>Amount</div>
            <div>Actions</div>
          </FeeListHeader>
          {groups.map((group) => (
            <FeeListRow key={group.id || `${group.representation_type}-${group.paid_by}-${group.fee_type}-${group.amount}-${group.percentage}`}>
              <div>{this.getRepresentationTypeLabel(group.representation_type)}</div>
              <div>{this.getRadiusFeeAmountLabel(group)}</div>
              <FeeListActions>
                <Button type="link" icon={<EditOutlined />} onClick={() => onEdit(group)} />
                <Button type="link" danger icon={<DeleteOutlined />} onClick={() => onDelete(group)} />
              </FeeListActions>
            </FeeListRow>
          ))}
          {onAdd ? (
            <FeeListRow>
              <div>
                <Button type="link" icon={<PlusOutlined />} onClick={onAdd}>
                  Add Fee
                </Button>
              </div>
              <div />
              <div />
            </FeeListRow>
          ) : null}
        </FeeListCard>
      </FeeListContainer>
    )
  }

  renderTeamFeeList = ({ fees = [], onEdit, onDelete, onAdd }) => {
    return (
      <FeeListContainer>
        <FeeListCard>
          <TeamFeeListHeader>
            <div>Fee Name</div>
            <div>Representation</div>
            <div>Amount</div>
            <div>Actions</div>
          </TeamFeeListHeader>
          {fees.map((fee) => {
            const representationLabels = this.getTeamFeeRepresentationTypes(fee)
              .map(this.getRepresentationTypeLabel)
              .join(", ")

            return (
              <TeamFeeListRow key={fee.id || `${this.getTeamFeeDisplayName(fee)}-${representationLabels}`}>
                <div>{this.getTeamFeeDisplayName(fee)}</div>
                <div>{representationLabels || "-"}</div>
                <div>{this.getTeamFeeAmountLabel(fee)}</div>
                <FeeListActions>
                  <Button type="link" icon={<EditOutlined />} onClick={() => onEdit(fee)} />
                  <Button type="link" danger icon={<DeleteOutlined />} onClick={() => onDelete(fee)} />
                </FeeListActions>
              </TeamFeeListRow>
            )
          })}
          {onAdd ? (
            <TeamFeeListRow>
              <div>
                <Button type="link" icon={<PlusOutlined />} onClick={onAdd}>
                  Add Fee
                </Button>
              </div>
              <div />
              <div />
              <div />
            </TeamFeeListRow>
          ) : null}
        </FeeListCard>
      </FeeListContainer>
    )
  }

  // ================= Post-Cap Fee helpers =================
  // Raw rows as returned by the backend (one row per representation type).
  getPostCapFeesForScope = (scope, agentId) => {
    if (scope === "team") {
      const teamFees = this.state && this.state.teamPostCapFees
      return Array.isArray(teamFees) ? teamFees : []
    }
    if (agentId === null || agentId === undefined) return []
    const map = (this.state && this.state.agentPostCapFeesByAgentId) || {}
    const agentFees = map[agentId]
    return Array.isArray(agentFees) ? agentFees : []
  }

  // Read the fee kind from a raw row (response uses `radius_fee_kind`).
  getPostCapKind = (row) => (row && (row.radius_fee_kind || row.fee_type_kind)) || null

  // Collapse per-representation rows into one logical plan per fee kind.
  getPostCapGroups = (fees = []) => {
    const rows = Array.isArray(fees) ? fees : []
    const byKind = {}
    rows.forEach((row) => {
      if (!row) return
      const kind = this.getPostCapKind(row)
      if (!kind) return
      if (!byKind[kind]) {
        byKind[kind] = {
          kind,
          ids: [],
          rows: [],
          amount: row.amount,
          percentage: row.percentage,
          paid_by: row.paid_by,
          cap_collection_mode: row.cap_collection_mode,
          set_as_team_cap: Boolean(row.set_as_team_cap),
        }
      }
      if (row.id !== null && row.id !== undefined) byKind[kind].ids.push(row.id)
      byKind[kind].rows.push(row)
    })
    return POST_CAP_FEE_TYPES.map((kind) => byKind[kind]).filter(Boolean)
  }

  getPostCapGroupsForScope = (scope, agentId) => this.getPostCapGroups(this.getPostCapFeesForScope(scope, agentId))

  // Which fee kinds are still selectable (radius/audit) for the given scope.
  getAvailablePostCapFeeTypes = (fees = [], editingKind = null) => {
    const takenKinds = this.getPostCapGroups(fees)
      .map((group) => group && group.kind)
      .filter((kind) => kind && kind !== editingKind)
    return POST_CAP_FEE_TYPES.filter((kind) => !takenKinds.includes(kind))
  }

  isPostCapFeeTypeDisabled = (kind) => {
    const { postCapFeeModalScope, selectedPostCapAgent, postCapEditingKind } = this.state
    const agentId = selectedPostCapAgent ? selectedPostCapAgent.id : null
    const existing = this.getPostCapFeesForScope(postCapFeeModalScope, agentId)
    return !this.getAvailablePostCapFeeTypes(existing, postCapEditingKind).includes(kind)
  }

  getPostCapFeeTypeLabel = (kind) => (kind && POST_CAP_FEE_TYPE_LABELS[kind]) || kind || "-"

  getPostCapFeePayerLabel = (payer) => (payer && POST_CAP_FEE_PAYER_LABELS[payer]) || payer || "-"

  getPostCapAmountLabel = (group) => {
    const amount = group && group.amount
    if (amount === null || amount === undefined || amount === "") return "-"
    return `$${this.formatDecimalValue(amount)}`
  }

  openPostCapFeeModal = ({ scope, agentRecord = null, group = null }) => {
    const agentId = agentRecord ? agentRecord.id : null
    const existingFees = this.getPostCapFeesForScope(scope, agentId)
    const availableTypes = this.getAvailablePostCapFeeTypes(existingFees, group ? group.kind : null)
    // If a radius fee already exists, default the new one to audit (and vice versa).
    const defaultKind = group ? group.kind : (availableTypes[0] || "radius_fee")
    // Map backend cap_collection_mode back to a dropdown value.
    const dealBehavior = group && group.cap_collection_mode ? group.cap_collection_mode : "remaining_only"
    this.setState({
      showPostCapFeeModal: true,
      postCapFeeModalScope: scope,
      postCapFeeModalMode: group ? "edit" : "add",
      selectedPostCapAgent: agentRecord,
      postCapEditingKind: group ? group.kind : null,
      postCapEditingRows: (group && Array.isArray(group.rows)) ? group.rows : [],
      postCapSetAsTeamCap: group ? Boolean(group.set_as_team_cap) : false,
      postCapDealBehavior: dealBehavior,
      postCapFeeType: defaultKind,
      postCapFeePayer: (group && group.paid_by) || "team",
      postCapAmount: group ? this.formatDecimalValue(group.amount) : "",
    })
  }

  closePostCapFeeModal = () => {
    this.setState({
      showPostCapFeeModal: false,
      selectedPostCapAgent: null,
      postCapEditingKind: null,
      postCapEditingRows: [],
      isSavingPostCapFee: false,
    })
  }

  postCapEndpoint = (scope, teamId, agentId, extraQuery = "") => {
    const base = scope === "team"
      ? `${baseUrl}/v1.0/brokerage-team/post-cap-radius-fees`
      : `${baseUrl}/v1.0/brokerage-team/agent-post-cap-radius-fees`
    let query = `team_id=${teamId}`
    if (scope === "agent") query += `&agent_id=${agentId}`
    if (extraQuery) query += `&${extraQuery}`
    return `${base}?${query}`
  }

  savePostCapFeeModal = async () => {
    try {
      const {
        id: teamId,
        postCapFeeModalScope,
        selectedPostCapAgent,
        postCapEditingRows,
        postCapSetAsTeamCap,
        postCapDealBehavior,
        postCapFeeType,
        postCapFeePayer,
        postCapAmount,
      } = this.state

      if (!teamId) {
        message.info("Please save the team first before adding a post-cap plan")
        return
      }

      if (postCapFeeModalScope === "agent" && !(selectedPostCapAgent && selectedPostCapAgent.id)) {
        message.info("Please select an agent before adding a post-cap plan")
        return
      }

      const numericAmount = postCapAmount === "" ? null : Number(postCapAmount)
      if (numericAmount === null || Number.isNaN(numericAmount) || numericAmount <= 0) {
        message.error("Please enter a valid amount")
        return
      }

      const agentId = selectedPostCapAgent ? selectedPostCapAgent.id : null
      const commonFields = {
        team_id: teamId,
        fee_type: postCapFeeType, // kind: radius_fee | audit_fee (request uses fee_type)
        amount: numericAmount,
        paid_by: postCapFeePayer,
        cap_collection_mode: mapPostCapCapMode(postCapDealBehavior),
        set_as_team_cap: postCapSetAsTeamCap,
      }
      if (postCapFeeModalScope === "agent") commonFields.agent_id = agentId

      const isEdit = Array.isArray(postCapEditingRows) && postCapEditingRows.length > 0

      this.setState({ isSavingPostCapFee: true })

      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        "internal-id": token,
        "X-User-Agent": "agent-php",
      }

      let lastData = null
      if (isEdit) {
        // Edit every existing per-representation row for this plan by id.
        for (let i = 0; i < postCapEditingRows.length; i += 1) {
          const row = postCapEditingRows[i]
          if (!row || row.id === null || row.id === undefined) {
            // eslint-disable-next-line no-continue
            continue
          }
          const body = {
            ...commonFields,
            id: row.id,
          }
          if (row.representation_type) body.representation_type = row.representation_type
          // eslint-disable-next-line no-await-in-loop
          const response = await fetch(this.postCapEndpoint(postCapFeeModalScope, teamId, agentId), {
            method: "PUT",
            headers,
            body: JSON.stringify(body),
          })
          // eslint-disable-next-line no-await-in-loop
          lastData = await response.json()
          if (!(response.ok && lastData && ((lastData.response && lastData.response.success) || lastData.success))) {
            message.error((lastData && lastData.error && lastData.error.message) || "Failed to update post-cap plan")
            this.setState({ isSavingPostCapFee: false })
            return
          }
        }
      } else {
        // Create: one call covering all representation types.
        const body = {
          ...commonFields,
          representation_types: POST_CAP_ALL_REPRESENTATION_TYPES,
        }
        const response = await fetch(this.postCapEndpoint(postCapFeeModalScope, teamId, agentId), {
          method: "PUT",
          headers,
          body: JSON.stringify(body),
        })
        lastData = await response.json()
        if (!(response.ok && lastData && ((lastData.response && lastData.response.success) || lastData.success))) {
          message.error((lastData && lastData.error && lastData.error.message) || "Failed to add post-cap plan")
          this.setState({ isSavingPostCapFee: false })
          return
        }
      }

      // Prefer fees returned by the response; otherwise refetch.
      const fromResponse = this.parsePostCapFeesResponse(lastData)
      if (postCapFeeModalScope === "team") {
        const teamPostCapFees = fromResponse.length ? fromResponse : await this.fetchTeamPostCapFees(teamId)
        this.setState({ teamPostCapFees, expandedTeamPostCapFees: true })
      } else {
        const agentFees = fromResponse.length ? fromResponse : await this.fetchAgentPostCapFees(teamId, agentId)
        this.setState((prev) => ({
          agentPostCapFeesByAgentId: {
            ...prev.agentPostCapFeesByAgentId,
            [agentId]: agentFees,
          },
        }))
      }

      message.success(`Post-cap plan ${isEdit ? "updated" : "added"} successfully!`)
      this.closePostCapFeeModal()
    } catch (error) {
      console.error("Error saving post-cap plan:", error)
      message.error("Something went wrong. Please try again.")
      this.setState({ isSavingPostCapFee: false })
    }
  }

  deletePostCapFee = ({ scope, agentRecord = null, group }) => {
    if (!group) return
    const groupIds = Array.isArray(group.ids) ? group.ids.filter((feeId) => feeId !== null && feeId !== undefined) : []
    if (!groupIds.length) {
      message.error("Nothing to delete for this post-cap plan")
      return
    }
    confirm({
      title: "Delete this post-cap plan?",
      icon: <ExclamationCircleOutlined />,
      content: `${this.getPostCapFeeTypeLabel(group.kind)} · ${this.getPostCapAmountLabel(group)}`,
      okText: "Delete",
      okType: "danger",
      cancelText: "Cancel",
      onOk: async () => {
        try {
          const { id: teamId } = this.state
          const agentId = agentRecord ? agentRecord.id : null
          const headers = {
            Accept: "application/json",
            "Content-Type": "application/json",
            "internal-id": token,
            "X-User-Agent": "agent-php",
          }

          let lastData = null
          // Remove every per-representation row belonging to this plan.
          for (let i = 0; i < groupIds.length; i += 1) {
            const feeId = groupIds[i]
            // eslint-disable-next-line no-await-in-loop
            const response = await fetch(this.postCapEndpoint(scope, teamId, agentId, `id=${feeId}`), {
              method: "DELETE",
              headers,
            })
            // eslint-disable-next-line no-await-in-loop
            lastData = await response.json()
            if (!(response.ok && lastData && ((lastData.response && lastData.response.success) || lastData.success))) {
              message.error((lastData && lastData.error && lastData.error.message) || "Failed to delete post-cap plan")
              return
            }
          }

          const fromResponse = this.parsePostCapFeesResponse(lastData)
          if (scope === "team") {
            const teamPostCapFees = fromResponse.length ? fromResponse : await this.fetchTeamPostCapFees(teamId)
            this.setState((prev) => ({
              teamPostCapFees,
              expandedTeamPostCapFees: teamPostCapFees.length > 0 ? prev.expandedTeamPostCapFees : false,
            }))
          } else if (agentId) {
            const agentFees = fromResponse.length ? fromResponse : await this.fetchAgentPostCapFees(teamId, agentId)
            this.setState((prev) => ({
              agentPostCapFeesByAgentId: {
                ...prev.agentPostCapFeesByAgentId,
                [agentId]: agentFees,
              },
            }))
          }
          message.success("Post-cap plan deleted successfully!")
        } catch (error) {
          console.error("Error deleting post-cap plan:", error)
          message.error("Something went wrong. Please try again.")
        }
      },
    })
  }

  renderPostCapFeeList = ({ scope, agentRecord = null, groups = [], canAddMore }) => {
    const safeGroups = (Array.isArray(groups) ? groups : []).filter(Boolean)
    return (
      <FeeListContainer>
        <FeeListCard>
          <PostCapListHeader>
            <div>Fee Type</div>
            <div>Fee Payer</div>
            <div>Amount</div>
            <div>Team Cap</div>
            <div>Actions</div>
          </PostCapListHeader>
          {safeGroups.map((group) => (
            <PostCapListRow key={group.kind}>
              <div>{this.getPostCapFeeTypeLabel(group.kind)}</div>
              <div>{this.getPostCapFeePayerLabel(group.paid_by)}</div>
              <div>{this.getPostCapAmountLabel(group)}</div>
              <div>{group.set_as_team_cap ? <span style={{ color: "#1890ff" }}>Yes</span> : "—"}</div>
              <FeeListActions>
                <Button type="link" icon={<EditOutlined />} onClick={() => this.openPostCapFeeModal({ scope, agentRecord, group })} />
                <Button type="link" danger icon={<DeleteOutlined />} onClick={() => this.deletePostCapFee({ scope, agentRecord, group })} />
              </FeeListActions>
            </PostCapListRow>
          ))}
          {canAddMore ? (
            <PostCapListRow>
              <div>
                <Button type="link" style={{ paddingLeft: 0 }} icon={<PlusOutlined />} onClick={() => this.openPostCapFeeModal({ scope, agentRecord })}>
                  Add Post-Cap
                </Button>
              </div>
              <div />
              <div />
              <div />
              <div />
            </PostCapListRow>
          ) : null}
        </FeeListCard>
      </FeeListContainer>
    )
  }

  render() {
    const teamDIv = this.getCreateView()
    const InviteTCModal = this.getInviteTCModalView()
    const { history } = this.props
    const { showJobCreateModal, viewJobModal } = this.state
    const teamFeeForm = this.state.teamFeeForm || this.getDefaultTeamFeeForm()
    const isRadiusTeamFee = Boolean(teamFeeForm && teamFeeForm.feeNameType === "radius_fee")
    //const rowTitlesdiv = this.getRowtitlesDiv();
    const membersDiv = this.getMembersDiv()
    const TCsDiv = this.getTCsDiv()
    const teamFeeRecords = Array.isArray(this.state.teamFees) ? this.state.teamFees : []
    const teamPostCapFees = this.state.teamPostCapFees || []
    const teamPostCapGroups = this.getPostCapGroups(teamPostCapFees)
    const canAddMoreTeamPostCap = this.getAvailablePostCapFeeTypes(teamPostCapFees).length > 0
    const modalTitleName = this.state.radiusFeeModalScope === "team"
      ? "Team Radius Fee"
      : (
        this.state.selectedAgentRadiusFee
          ? `${this.state.selectedAgentRadiusFee.firstname || ""} ${this.state.selectedAgentRadiusFee.lastname || ""}`.trim()
          : ""
      )
    const teamFeeModalTitle = this.state.teamFeeModalScope === "team"
      ? "Configure team-level fee details."
      : (
        this.state.selectedAgentTeamFee
          ? `${this.state.selectedAgentTeamFee.firstname || ""} ${this.state.selectedAgentTeamFee.lastname || ""}`.trim()
          : "Configure agent-level fee details."
      )
  
    console.log("this.state=======", this.state)
    return (
      <Wrap>
        <JobCreateModal visible={showJobCreateModal} onClose={() => this.handleOpenJobCreateModal(false)} teamInfo={this.state} />
        <JobViewModal visible={viewJobModal} onClose={() => this.handleViewJobModal(false)} teamInfo={this.state} />
        <Notifications />
        <Modal
          visible={this.state.showAgentRadiusFeeModal}
          title={
            <div>
              <div style={{ fontSize: 18, fontWeight: 700 }}>
                {this.state.radiusFeeModalMode === "edit" ? "Edit Radius Fee" : "Add Radius Fee"}
              </div>
              <div style={{ color: "#98a2b3", fontSize: 14, marginTop: 4 }}>
                {modalTitleName}
              </div>
            </div>
          }
          onCancel={this.closeAgentRadiusFeeModal}
          footer={[
            <Button key="cancel" onClick={this.closeAgentRadiusFeeModal}>
              Cancel
            </Button>,
            <Button
              key="save"
              type="primary"
              loading={this.state.isSavingAgentRadiusFee}
              onClick={this.saveRadiusFeeModal}
            >
              Save
            </Button>,
          ]}
        >
          <ModalSection>
            <ModalLabel>Representation Type</ModalLabel>
            <RepresentationChipWrap>
              {RADIUS_REPRESENTATION_TYPES.map((representationType) => {
                const selected = (this.state.radiusFeeModalRepresentations || []).includes(representationType)
                const disabled = this.isRadiusFeeRepresentationDisabled(representationType)
                return (
                  <RepresentationChip
                    key={representationType}
                    type={selected ? "primary" : "default"}
                    onClick={() => {
                      if (!disabled) {
                        this.toggleRadiusFeeRepresentation(representationType)
                      }
                    }}
                    style={{
                      opacity: disabled ? 0.45 : 1,
                      borderColor: selected ? "#1890ff" : "#d9d9d9",
                      color: selected ? "#fff" : "#4a5568",
                      background: selected ? "#1890ff" : "#fff",
                      cursor: disabled ? "not-allowed" : "pointer",
                    }}
                  >
                    {this.getRepresentationTypeLabel(representationType)}
                  </RepresentationChip>
                )
              })}
            </RepresentationChipWrap>
          </ModalSection>

          <ModalSection>
            <ModalLabel>Who Pays</ModalLabel>
            <Select
              value={this.state.agentRadiusFeePaidBy}
              onChange={(value) => this.setState({ agentRadiusFeePaidBy: value })}
              style={{ width: "100%" }}
            >
              <Select.Option value="agent">Agent Pays</Select.Option>
              <Select.Option value="company">Team Pays</Select.Option>
            </Select>
          </ModalSection>

          <ModalSection>
            <ModalLabel>Fee Type</ModalLabel>
            <Select
              value={this.state.agentRadiusFeeType}
              onChange={(value) => this.setState({
                agentRadiusFeeType: value,
                agentRadiusFeeAmount: "",
                agentRadiusFeePercentage: "",
              })}
              style={{ width: "100%" }}
            >
              <Select.Option value="flat">Flat</Select.Option>
              <Select.Option value="percentage">Percentage</Select.Option>
              <Select.Option value="both">Both</Select.Option>
            </Select>
          </ModalSection>

          <ModalSection style={{ marginBottom: 0 }}>
            {this.state.agentRadiusFeeType === "flat" || this.state.agentRadiusFeeType === "both" ? (
              <div style={{ marginBottom: this.state.agentRadiusFeeType === "both" ? 18 : 0 }}>
                <ModalLabel>Flat Amount</ModalLabel>
                <Input.Group compact>
                  <Input value="$" disabled style={{ width: 40, textAlign: "center" }} />
                  <Input
                    placeholder="0.00"
                    value={this.state.agentRadiusFeeAmount}
                    onChange={(e) => this.setState({ agentRadiusFeeAmount: e.target.value })}
                    style={{ width: "calc(100% - 40px)" }}
                  />
                </Input.Group>
              </div>
            ) : null}

            {this.state.agentRadiusFeeType === "percentage" || this.state.agentRadiusFeeType === "both" ? (
              <div>
                <ModalLabel>Percentage</ModalLabel>
                <Input.Group compact>
                  <Input
                    placeholder="0.00"
                    value={this.state.agentRadiusFeePercentage}
                    onChange={(e) => this.setState({ agentRadiusFeePercentage: e.target.value })}
                    style={{ width: "calc(100% - 40px)" }}
                  />
                  <Input value="%" disabled style={{ width: 40, textAlign: "center" }} />
                </Input.Group>
              </div>
            ) : null}
          </ModalSection>
        </Modal>
        <Modal
          visible={this.state.showTeamFeeModal}
          title={
            <div>
              <div style={{ fontSize: 18, fontWeight: 700 }}>
                {this.state.teamFeeModalMode === "edit" ? "Edit Fee" : "Add Fee"}
              </div>
              <div style={{ color: "#98a2b3", fontSize: 14, marginTop: 4 }}>
                {teamFeeModalTitle}
              </div>
            </div>
          }
          onCancel={this.closeTeamFeeModal}
          footer={[
            <Button key="cancel" onClick={this.closeTeamFeeModal}>
              Cancel
            </Button>,
            <Button
              key="save"
              type="primary"
              loading={this.state.isSavingTeamFee}
              onClick={this.saveTeamFeeModal}
            >
              Save Fee Type
            </Button>,
          ]}
          width={860}
        >
          <ModalSection>
            <ModalLabel>Fee Name</ModalLabel>
            <Select
              value={teamFeeForm.feeNameType}
              onChange={(value) => this.updateTeamFeeForm({
                feeNameType: value,
                countsTowardCap: value === "radius_fee"
                  ? true
                  : Boolean(teamFeeForm && teamFeeForm.countsTowardCap),
              })}
              placeholder="Select a fee"
              style={{ width: "100%" }}
              disabled={this.state.teamFeeModalMode === "edit"}
            >
              {TEAM_FEE_NAME_OPTIONS.map((option) => (
                <Select.Option key={option.value} value={option.value}>
                  {option.label}
                </Select.Option>
              ))}
            </Select>
            {teamFeeForm.feeNameType === "other_fee" ? (
              <Input
                placeholder="Enter fee name"
                value={teamFeeForm.customFeeName}
                onChange={(e) => this.updateTeamFeeForm({ customFeeName: e.target.value })}
                style={{ marginTop: 12 }}
                disabled={this.state.teamFeeModalMode === "edit"}
              />
            ) : null}
          </ModalSection>

          <ModalSection>
            <ModalLabel>Representation Type</ModalLabel>
            <TeamFeeRepresentationGrid>
              {RADIUS_REPRESENTATION_TYPES.map((representationType) => (
                <TeamFeeRepresentationChip
                  key={representationType}
                  type={(teamFeeForm.representationTypes || []).includes(representationType) ? "primary" : "default"}
                  onClick={() => {
                    if (this.state.teamFeeModalMode !== "edit") {
                      this.toggleTeamFeeRepresentationType(representationType)
                    }
                  }}
                  style={{
                    borderColor: (teamFeeForm.representationTypes || []).includes(representationType) ? "#1890ff" : "#d9d9d9",
                    color: (teamFeeForm.representationTypes || []).includes(representationType) ? "#fff" : "#4a5568",
                    background: (teamFeeForm.representationTypes || []).includes(representationType) ? "#1890ff" : "#fff",
                    boxShadow: (teamFeeForm.representationTypes || []).includes(representationType)
                      ? "0 8px 18px rgba(24, 144, 255, 0.18)"
                      : "none",
                    opacity: this.state.teamFeeModalMode === "edit" && !(teamFeeForm.representationTypes || []).includes(representationType) ? 0.55 : 1,
                    cursor: this.state.teamFeeModalMode === "edit" ? "default" : "pointer",
                  }}
                >
                  {this.getRepresentationTypeLabel(representationType)}
                </TeamFeeRepresentationChip>
              ))}
            </TeamFeeRepresentationGrid>
            <TeamFeeOptionHint>
              {this.state.teamFeeModalMode === "edit"
                ? "Fee name and representation type stay fixed while editing an existing custom fee."
                : "Choose every representation type this fee should apply to."}
            </TeamFeeOptionHint>
          </ModalSection>

          <ModalGridTwo>
            <ModalSection>
              <ModalLabel>Fee Type</ModalLabel>
              <Select
                value={teamFeeForm.pricingModel}
                onChange={(value) => this.updateTeamFeeForm({
                  pricingModel: value,
                  amount: value === "percentage" ? "" : teamFeeForm.amount,
                  percentage: value === "flat" ? "" : teamFeeForm.percentage,
                  notLessThanEnabled: value === "flat" ? false : teamFeeForm.notLessThanEnabled,
                  notLessThanAmount: value === "flat" ? "" : teamFeeForm.notLessThanAmount,
                  notToExceedEnabled: value === "flat" ? false : teamFeeForm.notToExceedEnabled,
                  notToExceedAmount: value === "flat" ? "" : teamFeeForm.notToExceedAmount,
                })}
                style={{ width: "100%" }}
              >
                {TEAM_FEE_TYPE_OPTIONS.map((option) => (
                  <Select.Option key={option.value} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))}
              </Select>
            </ModalSection>

            <ModalSection>
              <ModalLabel>{teamFeeForm.pricingModel === "percentage" ? "Percentage" : "Flat Fee"}</ModalLabel>
              <Input.Group compact>
                {teamFeeForm.pricingModel === "percentage" ? null : (
                  <Input value="$" disabled style={{ width: 48, textAlign: "center" }} />
                )}
                <Input
                  placeholder="0.00"
                  value={teamFeeForm.pricingModel === "percentage" ? teamFeeForm.percentage : teamFeeForm.amount}
                  onChange={(e) => this.updateTeamFeeForm(
                    teamFeeForm.pricingModel === "percentage"
                      ? { percentage: e.target.value }
                      : { amount: e.target.value }
                  )}
                  style={{
                    width: teamFeeForm.pricingModel === "percentage"
                      ? "calc(100% - 40px)"
                      : "calc(100% - 48px)",
                  }}
                  disabled={Boolean(teamFeeForm.usesSlidingScale)}
                />
                {teamFeeForm.pricingModel === "percentage" ? (
                  <Input value="%" disabled style={{ width: 40, textAlign: "center" }} />
                ) : null}
              </Input.Group>
            </ModalSection>
          </ModalGridTwo>

          <ModalGridThree>
            <ModalSection>
              <ModalLabel>When Applied</ModalLabel>
              <Select value="post-split" disabled style={{ width: "100%" }}>
                <Select.Option value="post-split">Post-Split</Select.Option>
              </Select>
            </ModalSection>
            <ModalSection>
              <ModalLabel>Fee Payer</ModalLabel>
              <Select
                value={teamFeeForm.paidBy}
                onChange={(value) => this.updateTeamFeeForm({ paidBy: value })}
                style={{ width: "100%" }}
              >
                {TEAM_FEE_PAYER_OPTIONS.map((option) => (
                  <Select.Option key={option.value} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))}
              </Select>
            </ModalSection>
            <ModalSection>
              <ModalLabel>Co-Agent Splits</ModalLabel>
              <Select
                value={teamFeeForm.coAgentSplit}
                onChange={(value) => this.updateTeamFeeForm({ coAgentSplit: value })}
                style={{ width: "100%" }}
              >
                {TEAM_FEE_SPLIT_OPTIONS.map((option) => (
                  <Select.Option key={option.value} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))}
              </Select>
            </ModalSection>
          </ModalGridThree>

          <ModalGridTwo>
            <ModalSection>
              <ModalLabel>Payable To</ModalLabel>
              <Input value="Radius" disabled />
            </ModalSection>
            <ModalSection>
              <ModalLabel>Payable Name</ModalLabel>
              <Input value="Radius" disabled />
            </ModalSection>
          </ModalGridTwo>

          <ModalGridTwo>
            <ModalSection>
              <div style={{ border: "1px solid #e8edf5", borderRadius: 8, padding: 16 }}>
                <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
                  <div>
                    <div style={{ fontSize: 16, fontWeight: 600 }}>Sliding Scale</div>
                    <div style={{ color: "#6b778c", marginTop: 4 }}>Enable tiered fee values.</div>
                  </div>
                  <Switch
                    checked={Boolean(teamFeeForm.usesSlidingScale)}
                    onChange={(checked) => this.setState((prevState) => {
                      const currentForm = prevState.teamFeeForm || this.getDefaultTeamFeeForm()
                      const currentTiers = Array.isArray(currentForm.slidingScaleTiers) && currentForm.slidingScaleTiers.length
                        ? currentForm.slidingScaleTiers
                        : [defaultTeamFeeTier(1)]
                      const normalizedTiers = currentTiers.map((tier, index) => ({
                        ...tier,
                        range_from:
                          index === 0
                          && (tier.range_from === null || tier.range_from === undefined || tier.range_from === "")
                            ? 0
                            : tier.range_from,
                      }))

                      return {
                        teamFeeForm: {
                          ...currentForm,
                          usesSlidingScale: checked,
                          amount: checked ? "" : currentForm.amount,
                          percentage: currentForm.pricingModel === "percentage" && checked ? "" : currentForm.percentage,
                          slidingScaleTiers: normalizedTiers,
                        },
                      }
                    })}
                  />
                </div>
              </div>
            </ModalSection>
            <ModalSection>
              <div style={{ border: "1px solid #e8edf5", borderRadius: 8, padding: 16 }}>
                <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
                  <div>
                    <div style={{ fontSize: 16, fontWeight: 600 }}>Contributes to Cap</div>
                    <div style={{ color: "#6b778c", marginTop: 4 }}>Count toward radius cap.</div>
                  </div>
                  <Switch
                    checked={isRadiusTeamFee ? true : Boolean(teamFeeForm && teamFeeForm.countsTowardCap)}
                    disabled={isRadiusTeamFee}
                    onChange={(checked) => this.updateTeamFeeForm({ countsTowardCap: checked })}
                  />
                </div>
              </div>
            </ModalSection>
          </ModalGridTwo>

          {teamFeeForm.usesSlidingScale ? (
            <ModalSection style={{ marginBottom: 0 }}>
              <TeamFeeTierWrap>
                <TeamFeeTierHeader>
                  <div>Over</div>
                  <div>Up To</div>
                  <div>{teamFeeForm.pricingModel === "flat" ? "Fee Amount" : "Fee %"}</div>
                  <div />
                </TeamFeeTierHeader>
                {(teamFeeForm.slidingScaleTiers || []).map((tier, idx) => (
                  <TeamFeeTierRow key={tier.id}>
                    <InputNumber
                      min={0}
                      placeholder="Over"
                      value={tier.range_from}
                      disabled={idx === 0}
                      onChange={(value) => this.updateTeamFeeTier(tier.id, "range_from", value)}
                      style={{ width: "100%" }}
                      formatter={(value) => {
                        if (value === null || value === undefined || value === "") return ""
                        return `$${`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                      }}
                      parser={(value) => String(value || "").replace(/\$\s?|(,*)/g, "")}
                    />
                    <InputNumber
                      min={0}
                      placeholder="Up to"
                      value={tier.range_to}
                      onChange={(value) => this.updateTeamFeeTier(tier.id, "range_to", value)}
                      style={{ width: "100%" }}
                      formatter={(value) => {
                        if (value === null || value === undefined || value === "") return ""
                        return `$${`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                      }}
                      parser={(value) => String(value || "").replace(/\$\s?|(,*)/g, "")}
                    />
                    <InputNumber
                      min={0}
                      max={teamFeeForm.pricingModel === "flat" ? undefined : 100}
                      placeholder={teamFeeForm.pricingModel === "percentage" ? "0.00" : "0.00"}
                      value={tier.percentage}
                      onChange={(value) => this.updateTeamFeeTier(tier.id, "percentage", value)}
                      style={{ width: "100%" }}
                      formatter={(value) => {
                        if (value === null || value === undefined || value === "") return ""
                        if (teamFeeForm.pricingModel !== "flat") return `${value}%`
                        return `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }}
                      parser={(value) => String(value || "").replace(/\$\s?|(,*)|%/g, "")}
                    />
                    <Button
                      type="text"
                      disabled={(teamFeeForm.slidingScaleTiers || []).length <= 1}
                      onClick={() => this.removeTeamFeeTier(tier.id)}
                    >
                      ×
                    </Button>
                  </TeamFeeTierRow>
                ))}
                <Button
                  type="dashed"
                  onClick={this.addTeamFeeTier}
                  disabled={!this.canAddTeamFeeTier()}
                  icon={<PlusOutlined />}
                >
                  Add Tier
                </Button>
                <TeamFeeTierHint>
                  Each new tier starts where the previous one ends, matching the Radius app sliding-scale fee setup.
                </TeamFeeTierHint>

                {teamFeeForm.pricingModel === "percentage" ? (
                  <TeamFeeTierLimitGrid>
                    <TeamFeeTierLimitRow>
                      <Checkbox
                        checked={Boolean(teamFeeForm.notLessThanEnabled)}
                        onChange={(e) => this.updateTeamFeeForm({ notLessThanEnabled: e.target.checked })}
                      >
                        Not less than
                      </Checkbox>
                      <InputNumber
                        min={0}
                        disabled={!teamFeeForm.notLessThanEnabled}
                        value={teamFeeForm.notLessThanAmount}
                        onChange={(value) => this.updateTeamFeeForm({ notLessThanAmount: value })}
                        style={{ width: "100%" }}
                        formatter={(value) => {
                          if (value === null || value === undefined || value === "") return ""
                          return `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        parser={(value) => String(value || "").replace(/\$\s?|(,*)/g, "")}
                      />
                    </TeamFeeTierLimitRow>
                    <TeamFeeTierLimitRow>
                      <Checkbox
                        checked={Boolean(teamFeeForm.notToExceedEnabled)}
                        onChange={(e) => this.updateTeamFeeForm({ notToExceedEnabled: e.target.checked })}
                      >
                        Not to exceed
                      </Checkbox>
                      <InputNumber
                        min={0}
                        disabled={!teamFeeForm.notToExceedEnabled}
                        value={teamFeeForm.notToExceedAmount}
                        onChange={(value) => this.updateTeamFeeForm({ notToExceedAmount: value })}
                        style={{ width: "100%" }}
                        formatter={(value) => {
                          if (value === null || value === undefined || value === "") return ""
                          return `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        parser={(value) => String(value || "").replace(/\$\s?|(,*)/g, "")}
                      />
                    </TeamFeeTierLimitRow>
                  </TeamFeeTierLimitGrid>
                ) : null}
              </TeamFeeTierWrap>
            </ModalSection>
          ) : null}
        </Modal>
        <Modal
          visible={this.state.showPostCapFeeModal}
          title={
            <div>
              <div style={{ fontSize: 18, fontWeight: 700 }}>
                {this.state.postCapFeeModalMode === "edit" ? "Edit Post-Cap Radius Fee" : "Add Post-Cap Radius Fee"}
              </div>
              <PostCapModalSubtitle>
                Fees that trigger once an agent's cap is reached. No tiers, no splits — a single fee.
              </PostCapModalSubtitle>
            </div>
          }
          onCancel={this.closePostCapFeeModal}
          footer={[
            <Button key="cancel" type="link" onClick={this.closePostCapFeeModal}>
              Cancel
            </Button>,
            <Button
              key="save"
              type="primary"
              loading={this.state.isSavingPostCapFee}
              disabled={!this.state.postCapAmount}
              onClick={this.savePostCapFeeModal}
            >
              Save Plan
            </Button>,
          ]}
        >
          <ModalSection style={{ marginBottom: 18 }}>
            <Checkbox
              checked={this.state.postCapSetAsTeamCap}
              onChange={(e) => this.setState({ postCapSetAsTeamCap: e.target.checked })}
            >
              Set as team cap
            </Checkbox>
          </ModalSection>

          <ModalSection>
            <PostCapFieldLabel>When deal caps the agent</PostCapFieldLabel>
            <Select
              value={this.state.postCapDealBehavior}
              onChange={(value) => this.setState({ postCapDealBehavior: value })}
              style={{ width: "100%" }}
            >
              {POST_CAP_DEAL_BEHAVIOR_OPTIONS.map((option) => (
                <Select.Option key={option.value} value={option.value}>{option.label}</Select.Option>
              ))}
            </Select>
          </ModalSection>

          <div style={{ display: "flex", gap: 16 }}>
            <ModalSection style={{ flex: 1 }}>
              <PostCapFieldLabel>Fee Type</PostCapFieldLabel>
              <Select
                value={this.state.postCapFeeType}
                onChange={(value) => this.setState({ postCapFeeType: value })}
                style={{ width: "100%" }}
              >
                {POST_CAP_FEE_TYPES.map((type) => (
                  <Select.Option key={type} value={type} disabled={this.isPostCapFeeTypeDisabled(type)}>
                    {POST_CAP_FEE_TYPE_LABELS[type]}
                  </Select.Option>
                ))}
              </Select>
            </ModalSection>

            <ModalSection style={{ flex: 1 }}>
              <PostCapFieldLabel>Fee Payer</PostCapFieldLabel>
              <Select
                value={this.state.postCapFeePayer}
                onChange={(value) => this.setState({ postCapFeePayer: value })}
                style={{ width: "100%" }}
              >
                <Select.Option value="team">Team</Select.Option>
                <Select.Option value="agent">Agent</Select.Option>
              </Select>
            </ModalSection>
          </div>

          <ModalSection style={{ marginBottom: 0 }}>
            <PostCapFieldLabel>Amount ($)</PostCapFieldLabel>
            <Input
              placeholder="250"
              value={this.state.postCapAmount}
              onChange={(e) => this.setState({ postCapAmount: e.target.value })}
            />
          </ModalSection>
        </Modal>
        <Header>
          <h1
            style={{
              display: "flex",
              alignItems: "baseline",
              marginLeft: "-40px",
            }}
          >
            <PageHeader
              className="site-page-header"
              onBack={() => history.push("/broker/teams/list")}
              title="Create/Edit Team"
              subTitle="Create/Edit Team Or Create/Edit Jobs"
            />
            &nbsp; &nbsp;
            <Button onClick={() => window.open(`https://radiusagent.com/teamprofile/${this.state.profile_name}`, "_blank")} type="link">View Team Public Page</Button>
            {/* <Button onClick={() => window.open(`https://staging.radiusagent.com/teamprofile/${this.state.profile_name}`, "_blank")} type="link">View Team Public Page</Button> */}
          </h1>
          <ControlsWrap>
            <Button ghost onClick={() => { history.push("/broker/teams/list") }}>
              Cancel
            </Button>
          </ControlsWrap>
          <ButtonWrap>
            <Button size="large" onClick={() => this.handleViewJobModal(true)} disabled={this.state.apiCallActive}>View Jobs</Button>
            <Button type="primary" size="large" onClick={() => this.handleOpenJobCreateModal(true)} disabled={this.state.apiCallActive}>Create Job</Button>
          </ButtonWrap>
        </Header>
        <Tabs defaultActiveKey="1" activeKey={this.state.activeKey} onChange={this.tabChange} tabBarExtraContent={
        <Button type="primary" style={{ marginRight: "45px" }} size="large" onClick={() => this.saveTeam({})} success disabled={!this.state.name}>
          Save
        </Button>
      }>
          <TabPane tab="Team Info" key="1">
            <br />
            <br />
            {teamDIv}
            <br />
            <br />
            <br />
            <br />
          </TabPane>
          <TabPane tab="Team Members" key="2">
            <>
              <br />
              <br />
              <InlineFieldRow style={{ paddingBottom: "12px" }}>
                <Button type="primary" onClick={() => this.handleOpenModal(true)} disabled={this.state.apiCallActive}>Add new team member</Button>
                <InlineFieldGroup>
                  <InlineFieldLabel>Team Cap:</InlineFieldLabel>
                  <TeamMemberInput 
                    placeholder="Enter team cap" 
                    value={this.state.teamCap || ''}
                    onChange={this.handleTeamCapChange}
                    onBlur={(e) => this.saveTeamCap(e.target.value)}
                    style={{ width: "200px" }}
                  />
                </InlineFieldGroup>
              </InlineFieldRow>
              <InlineFieldRow style={{ marginTop: "-4px", marginBottom: "10px" }}>
                <InlineFieldLabel>Team Fee:</InlineFieldLabel>
                {teamFeeRecords.length ? (
                  <RadiusFeeSummaryAction
                    type="link"
                    onClick={() => this.setState({ expandedTeamFees: !this.state.expandedTeamFees })}
                  >
                    {`${teamFeeRecords.length} fee${teamFeeRecords.length > 1 ? "s" : ""}`}
                    {this.state.expandedTeamFees ? <DownOutlined /> : <RightOutlined />}
                  </RadiusFeeSummaryAction>
                ) : null}
                <RadiusFeeAddButton
                  icon={<PlusOutlined />}
                  onClick={() => this.openTeamFeeModal({ scope: "team" })}
                >
                  Add
                </RadiusFeeAddButton>
              </InlineFieldRow>
              {this.state.expandedTeamFees && teamFeeRecords.length ? this.renderTeamFeeList({
                fees: teamFeeRecords,
                onEdit: (fee) => this.openTeamFeeModal({ scope: "team", fee }),
                onDelete: (fee) => this.deleteTeamFeeRecord({ scope: "team", fee }),
                onAdd: () => this.openTeamFeeModal({ scope: "team" }),
              }) : null}
              <InlineFieldRow style={{ marginTop: "-4px", marginBottom: "10px" }}>
                <InlineFieldLabel>Post Cap Fee:</InlineFieldLabel>
                {teamPostCapGroups.length ? (
                  <RadiusFeeSummaryAction
                    type="link"
                    onClick={() => this.setState({ expandedTeamPostCapFees: !this.state.expandedTeamPostCapFees })}
                  >
                    {`${teamPostCapGroups.length} fee${teamPostCapGroups.length > 1 ? "s" : ""}`}
                    {this.state.expandedTeamPostCapFees ? <DownOutlined /> : <RightOutlined />}
                  </RadiusFeeSummaryAction>
                ) : null}
                {canAddMoreTeamPostCap ? (
                  <RadiusFeeAddButton
                    icon={<PlusOutlined />}
                    onClick={() => this.openPostCapFeeModal({ scope: "team" })}
                  >
                    Add
                  </RadiusFeeAddButton>
                ) : null}
              </InlineFieldRow>
              {this.state.expandedTeamPostCapFees && teamPostCapGroups.length ? this.renderPostCapFeeList({
                scope: "team",
                groups: teamPostCapGroups,
                canAddMore: canAddMoreTeamPostCap,
              }) : null}
              <InlineFieldRow style={{ marginBottom: "18px" }}>
                <InlineFieldGroup>
                  <InlineFieldLabel>CDA Transparency Settings:</InlineFieldLabel>
                  <Select
                    value={this.state.cdaType || "full_transparency"}
                    onChange={this.handleCdaTypeChange}
                    style={{ width: 420 }}
                    disabled={!this.state.id || this.state.isSavingCdaType}
                    loading={this.state.isSavingCdaType}
                  >
                    <Select.Option value="full_transparency">Full Transparency</Select.Option>
                    <Select.Option value="radius_hidden">Radius Split Hidden</Select.Option>
                    <Select.Option value="team_hidden">Team Split Hidden</Select.Option>
                  </Select>
                </InlineFieldGroup>
                <InlineFieldGroup>
                  <InlineFieldLabel>CDA Settings:</InlineFieldLabel>
                  <Select
                    value={this.state.cdaSettings || "cda"}
                    onChange={this.handleCdaSettingsChange}
                    style={{ width: 220 }}
                    disabled={!this.state.id || this.state.isSavingCdaType}
                    loading={this.state.isSavingCdaType}
                  >
                    <Select.Option value="cda">CDA</Select.Option>
                    <Select.Option value="gross_cda">Gross CDA</Select.Option>
                  </Select>
                </InlineFieldGroup>
              </InlineFieldRow>
              <br />
              <span style={{ fontSize: 12, color: "#444" }}>Add new members to the team by clicking on the add agents button!</span>
              {this.state.members && this.state.members.length > 0

                && (
                  <div>
                    <span style={{ fontSize: 12, color: "#444" }}>If you want to change a team member's role, please delete them and add them again with the new role!</span>
                    <br />
                    <br />
                    <span>
                      {" "}
                      {"Team Members"}
                    </span>
                    <br />
                    <br />
                    <div>
                      {/* <div>
                {rowTitlesdiv}
              </div> */}
                      {membersDiv}
                    </div>
                  </div>
                )
              }
            </>
          </TabPane>
          <TabPane tab="Team TCs" key="3">
            <>
              <br />
              <br />
              <Button type="primary" onClick={() => this.handleOpenInviteTCModal(true)} disabled={this.state.apiCallActive}>Add new TC</Button>
              <br />
              <br />
              <span style={{ fontSize: 12, color: "#444" }}>Invite new TC to the team by clicking on the add TC button!</span>
              {this.state.members && this.state.members.length > 0

                && (
                  <div>
                    <span style={{ fontSize: 12, color: "#444" }}>If you want to change a team member's role, please delete them and add them again with the new role!</span>
                    <br />
                    <br />
                    <span>
                      {" "}
                      {"Team TCs"}
                    </span>
                    <br />
                    <br />
                    <div>
                      {/* <div>
                {rowTitlesdiv}
              </div> */}
                      {TCsDiv}
                      {InviteTCModal}
                    </div>
                  </div>
                )
              }
            </>
          </TabPane>
        </Tabs>
      </Wrap>
    )
  }
}

export default withRouter(BrokerageTeam)
